const email1 = {
  id: 1,
  passage: `Dear Customer Support Team,

I hope this message finds you well. I am writing to bring to your attention a concern regarding the delayed delivery of my recent order from your esteemed brand. As a valued customer, I have always appreciated the quality and service provided by your company, which makes this experience quite disappointing.

The order, placed on August 5, 2055, was expected to arrive by August 10, 2055, but unfortunately, it has not yet been delivered. Below are the details of the order for your reference:

- Order Number: 58420391
- Product Name: EcoComfort Memory Foam Pillow
- Quantity: 2

Understanding the <mark>unforeseen</mark> circumstances that may <mark>arise</mark> in logistics, I kindly request an update on the <mark>status</mark> of my shipment. Additionally, I would appreciate it if you could <mark>expedite</mark> the process to ensure its prompt delivery.

Your commitment to quality and customer satisfaction has always been <mark>admirable</mark>, and I trust that this issue will be resolved <mark>efficiently</mark>. Thank you for your attention to this matter, and I look forward to your prompt response.

Warm regards,

Julia Hart`,

  translation: `고객 지원팀에게,

안녕하세요. 귀사의 소중한 브랜드에서 최근 주문한 제품의 배송 지연에 관한 우려사항을 알려드리고자 이 메시지를 보냅니다. 가치 있는 고객으로서, 저는 항상 귀사가 제공하는 품질과 서비스에 감사해왔으며, 이번 경험은 꽤 실망스럽습니다.

2055년 8월 5일에 주문한 이 제품은 2055년 8월 10일까지 도착할 예정이었으나, 안타깝게도 아직 배송되지 않았습니다. 참고를 위해 주문 세부 정보는 다음과 같습니다:

- 주문 번호: 58420391
- 제품명: 에코컴포트 메모리폼 베개
- 수량: 2

물류에서 예상치 못한 상황이 발생할 수 있음을 이해하며, 제 배송 상태에 대한 업데이트를 요청드립니다. 또한, 신속한 배송을 위해 과정을 가속화해 주시면 감사하겠습니다.

귀사의 품질과 고객 만족에 대한 헌신은 항상 존경받을 만하며, 이 문제가 효율적으로 해결될 것이라 믿습니다. 이 문제에 관심을 가져주셔서 감사드리며, 신속한 답변을 기다리겠습니다.

따뜻한 인사를 보내며,

줄리아 하트`,
  koreanNouns: `Dear Customer Support Team,

I hope this message finds you well. I am writing to bring to your attention a concern regarding the delayed delivery of my recent order from your esteemed brand. As a valued customer, I have always appreciated the quality and service provided by your company, which makes this experience quite disappointing.

The order, placed on August 5, 2055, was expected to arrive by August 10, 2055, but unfortunately, it has not yet been delivered. Below are the details of the order for your reference:

- Order Number: 58420391
- Product Name: EcoComfort Memory Foam Pillow
- Quantity: 2

Understanding the <mark>예상치 못한</mark> circumstances that may <mark>발생하다</mark> in logistics, I kindly request an update on the <mark>상태</mark> of my shipment. Additionally, I would appreciate it if you could <mark>가속화하다</mark> the process to ensure its prompt delivery.

Your commitment to quality and customer satisfaction has always been <mark>감탄할만한</mark>, and I trust that this issue will be resolved <mark>효율적으로</mark>. Thank you for your attention to this matter, and I look forward to your prompt response.

Warm regards,

Julia Hart`,
  wordPairs: {
    unforeseen: "예상치 못한",
    arise: "발생하다",
    status: "상태",
    expedite: "가속화하다",
    admirable: "감탄할만한",
    efficiently: "효율적으로",
  },

  questions: [],
};
const email2 = {
  id: 2,
  passage: `Dear NovaTech Customer Service Team,

I hope this message finds you well. I am writing to <mark>express</mark> my <mark>dissatisfaction</mark> with the customer service experience I recently <mark>encountered</mark> with your company. I believe it is important for you to <mark>be aware of</mark> the issues in order to enhance and <mark>embody</mark> your brand's unique identity through excellent service.

The concerns I encountered include:

- Lack of <mark>timely</mark> response: I <mark>reached out</mark> for assistance on August 8, 2055, and did not receive a reply until August 14, which is <mark>unsatisfactory</mark> for a company of your <mark>reputation</mark>.
- <mark>Inadequate</mark> problem resolution: The solution provided was not helpful and did not address my concerns effectively. I had to follow up three times to receive appropriate support.
- Unprofessional communication: During our <mark>interaction</mark>, the <mark>customer service representative</mark> displayed a lack of knowledge regarding the company's policies and was unable to provide <mark>clear</mark> guidance.

These issues have <mark>certainly</mark> impacted my <mark>perception</mark> of NovaTech. I <mark>urge</mark> you to look into these matters and take the necessary steps to improve your customer service operations.

Your attention to this matter would be <mark>greatly</mark> appreciated. I look forward to hearing how you intend to address these issues.

Thank you for your time and understanding. Please do not hesitate to contact me at j.smith@email.com or (555) 238-9045 should you require any further details regarding these incidents.

Best regards,

Jordan Smith`,

  translation: `노바테크 고객 서비스팀에게,

안녕하세요. 저는 최근 귀사와의 고객 서비스 경험에 대한 불만을 표현하기 위해 이 메시지를 보냅니다. 귀사가 우수한 서비스를 통해 브랜드의 고유한 정체성을 향상시키고 구현할 수 있도록 이러한 문제점을 알려드리는 것이 중요하다고 생각합니다.

제가 겪은 문제점은 다음과 같습니다:

- 적시 응답 부족: 2055년 8월 8일에 도움을 요청했으나, 8월 14일까지 답변을 받지 못했습니다. 이는 귀사의 명성에 비해 만족스럽지 못합니다.
- 부적절한 문제 해결: 제공된 해결책은 도움이 되지 않았으며 제 우려사항을 효과적으로 해결하지 못했습니다. 적절한 지원을 받기 위해 세 번이나 후속 조치를 취해야 했습니다.
- 비전문적인 의사소통: 상호작용 중에 고객 서비스 담당자는 회사 정책에 대한 지식이 부족했으며 명확한 안내를 제공할 수 없었습니다.

이러한 문제들은 분명히 노바테크에 대한 제 인식에 영향을 미쳤습니다. 이러한 문제를 검토하고 고객 서비스 운영을 개선하기 위해 필요한 조치를 취해주시기 바랍니다.

이 문제에 관심을 가져주시면 감사하겠습니다. 이러한 문제를 어떻게 해결할 계획인지 듣고 싶습니다.

시간과 이해에 감사드립니다. 이러한 사건에 관한 추가 세부 정보가 필요하시면 j.smith@email.com 또는 (555) 238-9045로 연락해 주십시오.

감사합니다,

조던 스미스`,

  koreanNouns: `Dear NovaTech Customer Service Team,

I hope this message finds you well. I am writing to <mark>표현하다</mark> my <mark>불만</mark> with the customer service experience I recently <mark>겪다</mark> with your company. I believe it is important for you to <mark>알다</mark> the issues in order to enhance and <mark>구현하다</mark> your brand's unique identity through excellent service.

The concerns I encountered include:

- Lack of <mark>적시의</mark> response: I <mark>연락했다</mark> for assistance on August 8, 2055, and did not receive a reply until August 14, which is <mark>만족스럽지 못한</mark> for a company of your <mark>명성</mark>.
- <mark>부적절한</mark> problem resolution: The solution provided was not helpful and did not address my concerns effectively. I had to follow up three times to receive appropriate support.
- Unprofessional communication: During our <mark>상호작용</mark>, the <mark>고객 서비스 담당자</mark> displayed a lack of knowledge regarding the company's policies and was unable to provide <mark>명확한</mark> guidance.

These issues have <mark>분명히</mark> impacted my <mark>인식</mark> of NovaTech. I <mark>촉구하다</mark> you to look into these matters and take the necessary steps to improve your customer service operations.

Your attention to this matter would be <mark>크게</mark> appreciated. I look forward to hearing how you intend to address these issues.

Thank you for your time and understanding. Please do not hesitate to contact me at j.smith@email.com or (555) 238-9045 should you require any further details regarding these incidents.

Best regards,

Jordan Smith`,
  wordPairs: {
    express: "표현하다",
    dissatisfaction: "불만",
    encountered: "겪다",
    "be aware of": "알다",
    embody: "구현하다",
    timely: "적시의",
    "reached out": "연락했다",
    unsatisfactory: "만족스럽지 못한",
    reputation: "명성",
    inadequate: "부적절한",
    interaction: "상호작용",
    "customer service representative": "고객 서비스 담당자",
    clear: "명확한",
    certainly: "분명히",
    perception: "인식",
    urge: "촉구하다",
    greatly: "크게",
  },

  questions: [],
};

const email3 = {
  id: 3,
  passage: `Dear Oak & Ember Customer Service Team,

I am writing to express my dissatisfaction with a recent purchase from your company, which unfortunately does not match the <mark>description</mark> provided. I have been a <mark>loyal customer</mark> for some time, and this is the first <mark>occasion</mark> where I have encountered such an issue.

The product, Heritage Leather Messenger Bag, was described as having <mark>specific attributes</mark> that were <mark>pivotal</mark> in my decision to purchase it. However, upon receiving the item, I noticed the <mark>following</mark> <mark>discrepancies</mark>:

- Color: The product was advertised in dark brown, but the one I received is <mark>light tan</mark>.
- Size: I ordered the product in size Large, <mark>yet</mark> the product delivered is Medium, which does not fit my <mark>needs</mark>.
- Functionality: The description mentioned a padded laptop compartment, but the product lacks this feature, affecting its <mark>usability</mark> for my work requirements.

These discrepancies have caused significant inconvenience, and I kindly request a resolution to this matter. I would appreciate it if you could arrange for the correct item to be sent or a refund to be processed at your earliest convenience.

Enclosed, I have attached photos of the received product <mark>along with</mark> copies of the original order confirmation for your reference.

Please let me know how you propose to resolve this issue. I look forward to your prompt response, ensuring that the <mark>exceptional</mark> service your brand is known for continues.

Thank you for your attention to this matter.

Sincerely,

Daniel Kim`,

  translation: `오크 앤 엠버 고객 서비스팀께,

귀사에서 최근 구매한 제품이 제공된 설명과 일치하지 않아 불만을 표현하고자 이 글을 씁니다. 저는 오랫동안 충성스러운 고객이었으며, 이런 문제를 겪은 것은 이번이 처음입니다.

'헤리티지 가죽 메신저 백'이라는 제품은 제가 구매를 결정하는 데 중요했던 특정 속성을 가지고 있다고 설명되었습니다. 그러나 제품을 받아보니 다음과 같은 불일치를 발견했습니다:

- 색상: 제품은 짙은 갈색으로 광고되었지만, 제가 받은 것은 밝은 황갈색입니다.
- 크기: 라지 사이즈로 주문했지만, 배송된 제품은 미디엄 사이즈로 제 필요에 맞지 않습니다.
- 기능성: 설명에는 노트북 수납 공간이 있다고 언급되었지만, 제품에는 이 기능이 없어 업무용으로 사용하는 데 영향을 미칩니다.

이러한 불일치로 인해 상당한 불편함이 발생했으며, 이 문제에 대한 해결책을 요청드립니다. 가능한 빨리 올바른 제품을 보내주시거나 환불 처리를 해주시면 감사하겠습니다.

참고를 위해 받은 제품의 사진과 원래 주문 확인서 사본을 첨부했습니다.

이 문제를 어떻게 해결할 계획인지 알려주십시오. 귀사의 브랜드가 알려진 뛰어난 서비스가 계속되도록 신속한 응답을 기대합니다.

이 문제에 관심을 가져주셔서 감사합니다.

감사합니다,

다니엘 김`,

  koreanNouns: `Dear Oak & Ember Customer Service Team,

I am writing to express my dissatisfaction with a recent purchase from your company, which unfortunately does not match the <mark>설명</mark> provided. I have been a <mark>단골</mark> for some time, and this is the first <mark>경우</mark> where I have encountered such an issue.

The product, Heritage Leather Messenger Bag, was described as having <mark>특정 속성</mark> that were <mark>중요했던</mark> in my decision to purchase it. However, upon receiving the item, I noticed the <mark>다음의</mark> <mark>불일치</mark>:

- Color: The product was advertised in dark brown, but the one I received is <mark>밝은 황갈색</mark>.
- Size: I ordered the product in size Large, <mark>하지만</mark> the product delivered is Medium, which does not fit my <mark>필요</mark>.
- Functionality: The description mentioned a padded laptop compartment, but the product lacks this feature, affecting its <mark>사용편의성</mark> for my work requirements.

These discrepancies have caused significant inconvenience, and I kindly request a resolution to this matter. I would appreciate it if you could arrange for the correct item to be sent or a refund to be processed at your earliest convenience.

Enclosed, I have attached photos of the received product <mark>와 함께</mark> copies of the original order confirmation for your reference.

Please let me know how you propose to resolve this issue. I look forward to your prompt response, ensuring that the <mark>뛰어난</mark> service your brand is known for continues.

Thank you for your attention to this matter.

Sincerely,

Daniel Kim`,

  wordPairs: {
    description: "설명",
    "loyal customer": "단골",
    occasion: "경우",
    "specific attributes": "특정 속성",
    pivotal: "중요했던",
    following: "다음의",
    discrepancies: "불일치",
    "light tan": "밝은 황갈색",
    yet: "하지만",
    needs: "필요",
    usability: "사용편의성",
    "along with": "와 함께",
    exceptional: "뛰어난",
  },

  questions: [],
};
const email4 = {
  id: 4,
  passage: `Dear WestBrook Homeware Customer Service,

I am writing to express my disappointment and dissatisfaction with the recent order I received from your company. Unfortunately, the product was damaged upon arrival, which has caused significant inconvenience.

Order Details:

- Order Number: WB348721
- Product Name: Ceramic Vase – Midnight Blue (Large)
- Order Date: August 14, 2055

Upon receiving the package, I noticed that the product was not <mark>securely</mark> packed, and as a result, it was damaged during <mark>transit</mark>. This situation is <mark>profoundly</mark> <mark>unacceptable</mark> as it has <mark>disrupted</mark> my plans to gift the item at an upcoming <mark>housewarming event</mark> and led to an unpleasant experience with your brand.

I request a replacement product or a full refund for this item. Please find attached photographs of the damaged product as evidence for your reference.

I trust that you will address this matter with urgency and take appropriate <mark>measures</mark> to prevent such issues in the future. I look forward to your prompt response and a resolution to this problem.

Thank you for your immediate attention to this matter.

Sincerely,

Olivia Han`,

  translation: `웨스트브룩 홈웨어 고객 서비스팀께,

귀사로부터 최근 받은 주문에 대한 실망과 불만을 표현하고자 이 글을 씁니다. 불행히도, 제품이 도착 시 손상되어 있었으며, 이로 인해 상당한 불편을 겪었습니다.

주문 세부 정보:

- 주문 번호: WB348721
- 제품명: 세라믹 화병 - 미드나이트 블루 (대형)
- 주문 날짜: 2055년 8월 14일

패키지를 받았을 때, 제품이 안전하게 포장되지 않았고, 그 결과 운송 중에 손상되었음을 발견했습니다. 이 상황은 다가오는 집들이 행사에 선물할 계획이 방해받았고 귀사 브랜드와의 불쾌한 경험으로 이어져 매우 받아들일 수 없는 일입니다.

이 제품에 대한 교체품이나 전액 환불을 요청합니다. 참고용으로 손상된 제품의 사진을 첨부했으니 확인해 주십시오.

귀하께서 이 문제를 시급히 처리하고 향후 이러한 문제를 방지하기 위한 적절한 조치를 취해주실 것을 믿습니다. 신속한 응답과 이 문제에 대한 해결책을 기대합니다.

즉각적인 관심에 감사드립니다.

올리비아 한 드림`,
  koreanNouns: `Dear WestBrook Homeware Customer Service,

I am writing to express my disappointment and dissatisfaction with the recent order I received from your company. Unfortunately, the product was damaged upon arrival, which has caused significant inconvenience.

Order Details:

- Order Number: WB348721
- Product Name: Ceramic Vase – Midnight Blue (Large)
- Order Date: August 14, 2055

Upon receiving the package, I noticed that the product was not <mark>안전하게</mark> packed, and as a result, it was damaged during <mark>운송</mark>. This situation is <mark>매우</mark> <mark>받아들일 수 없는</mark> as it has <mark>방해받았고</mark> my plans to gift the item at an upcoming <mark>집들이 행사</mark> and led to an unpleasant experience with your brand.

I request a replacement product or a full refund for this item. Please find attached photographs of the damaged product as evidence for your reference.

I trust that you will address this matter with urgency and take appropriate <mark>조치</mark> to prevent such issues in the future. I look forward to your prompt response and a resolution to this problem.

Thank you for your immediate attention to this matter.

Sincerely,

Olivia Han`,

  wordPairs: {
    securely: "안전하게",
    transit: "운송",
    profoundly: "매우",
    unacceptable: "받아들일 수 없는",
    disrupted: "방해받았고",
    "housewarming event": "집들이 행사",
    measures: "조치",
  },

  questions: [],
};
const email5 = {
  id: 5,
  passage: `Dear Customer Service Team,

I am writing to express my strong dissatisfaction with the furniture <mark>assembly</mark> service I recently scheduled through your company.

On March 22, I had an appointment scheduled for the assembly of a dining table set at 1:00 PM. I <mark>cleared</mark> my entire afternoon for this appointment, yet no technician arrived. What made the situation worse was the complete lack of communication—I received no call, no message, and no email informing me of any delay, rescheduling, or cancellation.

After waiting for over three hours, I called your customer support line. The representative I spoke with could not give me a clear answer, only stating that "someone would follow up shortly." However, no one contacted me that day—or the day after. I had to call again <mark>myself</mark> to ask what happened, only to be told that they were still "checking with the technician."

This experience was <mark>extremely</mark> <mark>frustrating</mark>. I chose your company <mark>specifically</mark> because of the professional image you present online, but what I experienced was the <mark>opposite</mark>: a complete breakdown of communication, <mark>unfulfilled</mark> service, and no sense of <mark>accountability</mark>.

Here are the specific issues I encountered:

- The technician did not arrive at the promised time or date.
- I received no <mark>advance</mark> notice or follow-up regarding the delay.
- Your customer service could not provide a <mark>timely</mark> or helpful response.
- No one has contacted me to offer a new appointment, an apology, or compensation.

This experience has disrupted my schedule and damaged my trust in your service. I request the following actions to resolve this matter:

1. Immediate rescheduling of the furniture assembly within this week.
2. A full explanation of what caused the delay and lack of communication.
3. Compensation for the inconvenience caused—whether in the form of a service discount, <mark>voucher</mark>, or <mark>waived</mark> fees.

I expect a formal and prompt response to this message. I hope your company takes customer satisfaction <mark>seriously</mark> and will take the necessary steps to prevent this from happening again.

Sincerely,
Kim Minji`,
  translation: `고객 서비스팀께,

저는 최근 귀사를 통해 예약한 가구 조립 서비스에 대한 강한 불만을 표현하고자 이 글을 씁니다.

3월 22일, 저는 오후 1시에 식탁 세트 조립을 위한 약속이 예정되어 있었습니다. 이 약속을 위해 오후 일정을 모두 비웠지만, 기술자는 도착하지 않았습니다. 상황을 더 악화시킨 것은 완전한 소통 부재였습니다—지연, 일정 변경 또는 취소에 대한 어떠한 전화, 메시지, 이메일도 받지 못했습니다.

3시간 이상 기다린 후, 저는 귀사의 고객 지원 라인에 전화했습니다. 제가 통화한 담당자는 명확한 답변을 주지 못하고, 단지 "곧 누군가가 연락드릴 것"이라고만 말했습니다. 하지만, 그날도, 다음 날도 아무도 저에게 연락하지 않았습니다. 무슨 일이 있었는지 물어보기 위해 제가 직접 다시 전화해야 했고, 그들은 여전히 "기술자와 확인 중"이라는 답변만 했습니다.

이 경험은 매우 실망스러웠습니다. 저는 귀사가 온라인에서 보여주는 전문적인 이미지 때문에 특별히 선택했지만, 제가 경험한 것은 정반대였습니다: 소통의 완전한 붕괴, 이행되지 않은 서비스, 그리고 책임감의 부재였습니다.

제가 겪은 구체적인 문제는 다음과 같습니다:

- 기술자가 약속된 시간이나 날짜에 도착하지 않았습니다.
- 지연에 대한 사전 통지나 후속 조치를 받지 못했습니다.
- 귀사의 고객 서비스는 시기적절하거나 도움이 되는 응답을 제공하지 못했습니다.
- 새로운 약속, 사과, 또는 보상을 제안하기 위해 아무도 저에게 연락하지 않았습니다.

이 경험은 제 일정을 방해하고 귀사의 서비스에 대한 신뢰를 손상시켰습니다. 이 문제를 해결하기 위해 다음과 같은 조치를 요청합니다:

1. 이번 주 내에 가구 조립 일정 즉시 재조정.
2. 지연과 소통 부재의 원인에 대한 충분한 설명.
3. 서비스 할인, 바우처, 또는 수수료 면제 형태의 불편에 대한 보상.

저는 이 메시지에 대한 공식적이고 신속한 응답을 기대합니다. 귀사가 고객 만족을 진지하게 생각하고 이러한 일이 다시 발생하지 않도록 필요한 조치를 취하기를 바랍니다.

김민지 드림`,
  koreanNouns: `Dear Customer Service Team,

I am writing to express my strong dissatisfaction with the furniture <mark>조립</mark> service I recently scheduled through your company.

On March 22, I had an appointment scheduled for the assembly of a dining table set at 1:00 PM. I <mark>비웠다</mark> my entire afternoon for this appointment, yet no technician arrived. What made the situation worse was the complete lack of communication—I received no call, no message, and no email informing me of any delay, rescheduling, or cancellation.

After waiting for over three hours, I called your customer support line. The representative I spoke with could not give me a clear answer, only stating that "someone would follow up shortly." However, no one contacted me that day—or the day after. I had to call again <mark>내가 직접</mark> to ask what happened, only to be told that they were still "checking with the technician."

This experience was <mark>매우</mark> <mark>실망스러웠다</mark>. I chose your company <mark>특별히</mark> because of the professional image you present online, but what I experienced was the <mark>정반대</mark>: a complete breakdown of communication, <mark>이행되지 않은</mark> service, and no sense of <mark>책임감</mark>.

Here are the specific issues I encountered:

- The technician did not arrive at the promised time or date.
- I received no <mark>사전</mark> notice or follow-up regarding the delay.
- Your customer service could not provide a <mark>시기적절한</mark> or helpful response.
- No one has contacted me to offer a new appointment, an apology, or compensation.

This experience has disrupted my schedule and damaged my trust in your service. I request the following actions to resolve this matter:

1. Immediate rescheduling of the furniture assembly within this week.
2. A full explanation of what caused the delay and lack of communication.
3. Compensation for the inconvenience caused—whether in the form of a service discount, <mark>상품권</mark>, or <mark>면제된</mark> fees.

I expect a formal and prompt response to this message. I hope your company takes customer satisfaction <mark>진지하게</mark> and will take the necessary steps to prevent this from happening again.

Sincerely,
Kim Minji`,
  wordPairs: {
    assembly: "조립",
    cleared: "비웠다",
    myself: "내가 직접",
    extremely: "매우",
    frustrating: "실망스러웠다",
    specifically: "특별히",
    opposite: "정반대",
    unfulfilled: "이행되지 않은",
    accountability: "책임감",
    advance: "사전",
    timely: "시기적절한",
    voucher: "상품권",
    waived: "면제된",
    seriously: "진지하게",
  },
  questions: [],
};
const email6 = {
  id: 5,
  passage: `Subject: Formal Complaint Regarding Air Conditioning Repair Service

Dear Apex Home Services,

I hope this message finds you well. I am writing to express my <mark>deep</mark> dissatisfaction with the air conditioning repair service I recently received from your company. As a <mark>paying customer</mark>, I had expected a level of professionalism and <mark>reliability</mark> that your brand claims to <mark>uphold</mark>—but my experience, unfortunately, was quite the opposite.

The issues I encountered were not only <mark>frustrating</mark> but also concerning enough that I felt <mark>compelled</mark> to share them with you <mark>in detail</mark>.

Here are my main concerns:

Lack of Professionalism: The technician assigned to repair my air conditioning unit arrived over an hour late without any prior notice or apology. When he finally arrived, his <mark>demeanor</mark> was rushed and <mark>dismissive</mark>, and he appeared uninterested in <mark>thoroughly</mark> inspecting the issue.

Poor Communication: After the initial visit, I attempted to follow up with your team multiple times regarding the unresolved issue, but my calls and messages either went unanswered or were met with <mark>vague</mark> responses like "We'll get back to you soon," which never happened.

Substandard Service Quality: Despite the technician spending about 15 minutes on the unit, the cooling problem <mark>persists</mark>. The AC continues to shut off <mark>intermittently</mark> and fails to cool the room properly—exactly the issue I had reported <mark>in the first place</mark>.

Given the ongoing summer heat, this unresolved repair is not just inconvenient—it's affecting my comfort and daily life. I trusted your company to handle this service professionally, and I am disappointed by the lack of <mark>follow-through</mark> and <mark>accountability</mark> shown so far.

I respectfully request the following:

A follow-up visit by a qualified technician within the next 2–3 days to resolve the issue completely.
A clear explanation of what went wrong during the first service visit.
A <mark>gesture of compensation</mark> or discount for the inconvenience and unresolved issue.

I hope you will take this matter seriously and address these concerns with urgency. I look forward to a prompt and constructive response.

Sincerely,
Daniel Yoon`,
  translation: `제목: 에어컨 수리 서비스에 관한 공식 불만 사항

친애하는 Apex Home Services 귀하,

이 메시지가 귀하께 잘 전달되기를 바랍니다. 저는 최근 귀사로부터 받은 에어컨 수리 서비스에 대한 깊은 불만을 표현하고자 이 글을 씁니다. 비용을 지불한 고객으로서, 저는 귀사가 주장하는 전문성과 신뢰성을 기대했습니다—하지만 불행히도 제 경험은 정반대였습니다.

제가 겪은 문제들은 실망스러웠을 뿐만 아니라, 상세히 공유할 필요가 있다고 느낄 정도로 우려스러웠습니다.

다음은 제 주요 불만 사항입니다:

전문성 부족: 제 에어컨 수리를 담당한 기술자는 사전 통보나 사과 없이 한 시간 이상 늦게 도착했습니다. 그가 마침내 도착했을 때, 그의 태도는 서두르고 무시하는 듯했으며, 문제를 철저히 검사하는 데 관심이 없어 보였습니다.

소통 부재: 첫 방문 이후, 저는 해결되지 않은 문제에 관해 귀사 팀에 여러 번 연락을 시도했지만, 제 전화와 메시지는 응답이 없거나 "곧 연락드리겠습니다"와 같은 모호한 답변만 받았고, 결국 연락은 오지 않았습니다.

서비스 품질 미달: 기술자가 약 15분 동안 기기를 살펴봤음에도 불구하고, 냉각 문제는 지속됩니다. 에어컨은 계속해서 간헐적으로 꺼지고 방을 제대로 냉각시키지 못합니다—정확히 제가 처음에 보고했던 문제입니다.

현재 여름 더위를 고려할 때, 이 해결되지 않은 수리는 단순한 불편함을 넘어 제 편안함과 일상생활에 영향을 미치고 있습니다. 저는 귀사가 이 서비스를 전문적으로 처리할 것이라 믿었고, 지금까지 보여준 후속 조치와 책임감 부족에 실망했습니다.

저는 다음 사항을 정중히 요청합니다:

향후 2-3일 내에 자격을 갖춘 기술자의 후속 방문으로 문제를 완전히 해결해 주십시오.

첫 번째 서비스 방문 중 무엇이 잘못되었는지에 대한 명확한 설명을 부탁드립니다.

불편함과 해결되지 않은 문제에 대한 보상이나 할인 제공을 고려해 주십시오.

귀하께서 이 문제를 진지하게 받아들이고 시급히 해결해 주시기를 바랍니다. 신속하고 건설적인 응답을 기대합니다.

감사합니다,
다니엘 윤`,
  koreanNouns: `Subject: Formal Complaint Regarding Air Conditioning Repair Service

Dear Apex Home Services,

I hope this message finds you well. I am writing to express my <mark>깊은</mark> dissatisfaction with the air conditioning repair service I recently received from your company. As a <mark>비용을 지불한 고객</mark>, I had expected a level of professionalism and <mark>신뢰성</mark> that your brand claims to <mark>주장하는</mark>—but my experience, unfortunately, was quite the opposite.

The issues I encountered were not only <mark>실망스러웠을</mark> but also concerning enough that I felt <mark>필요가 있다고 느낄</mark> to share them with you <mark>상세히</mark>.

Here are my main concerns:

Lack of Professionalism: The technician assigned to repair my air conditioning unit arrived over an hour late without any prior notice or apology. When he finally arrived, his <mark>태도</mark> was rushed and <mark>무시하는 듯한</mark>, and he appeared uninterested in <mark>철저히</mark> inspecting the issue.

Poor Communication: After the initial visit, I attempted to follow up with your team multiple times regarding the unresolved issue, but my calls and messages either went unanswered or were met with <mark>모호한</mark> responses like "We'll get back to you soon," which never happened.

Substandard Service Quality: Despite the technician spending about 15 minutes on the unit, the cooling problem <mark>지속된다</mark>. The AC continues to shut off <mark>간헐적으로</mark> and fails to cool the room properly—exactly the issue I had reported <mark>처음에</mark>.

Given the ongoing summer heat, this unresolved repair is not just inconvenient—it's affecting my comfort and daily life. I trusted your company to handle this service professionally, and I am disappointed by the lack of <mark>후속 조치</mark> and <mark>책임감</mark> shown so far.

I respectfully request the following:

A follow-up visit by a qualified technician within the next 2–3 days to resolve the issue completely.
A clear explanation of what went wrong during the first service visit.
A <mark>보상의 표시</mark> or discount for the inconvenience and unresolved issue.

I hope you will take this matter seriously and address these concerns with urgency. I look forward to a prompt and constructive response.

Sincerely,
Daniel Yoon`,
  wordPairs: {
    deep: "깊은",
    "paying customer": "비용을 지불한 고객",
    reliability: "신뢰성",
    uphold: "주장하는",
    frustrating: "실망스러웠을",
    compelled: "필요가 있다고 느낄",
    "in detail": "상세히",
    demeanor: "태도",
    dismissive: "무시하는 듯한",
    thoroughly: "철저히",
    vague: "모호한",
    persists: "지속된다",
    intermittently: "간헐적으로",
    "in the first place": "처음에",
    "follow-through": "후속 조치",
    accountability: "책임감",
    "gesture of compensation": "보상의 표시",
  },
  questions: [],
};

const email7 = {
  id: 7,
  passage: `Subject: Concern Regarding Account Overcharge

Dear Billing Department,

I hope this message finds you well. I am writing to express my concern regarding a recent issue I encountered with an overcharge on my account. This situation has caused unexpected inconvenience, and I am eager to have it resolved promptly.

Upon reviewing my recent <mark>billing statement</mark>, I noticed <mark>discrepancies</mark> that do not align with the services provided. I believe a mistake has occurred, which resulted in a charge exceeding the <mark>agreed-upon amount</mark>. For your reference, here are the details of the overcharged invoice:

- Invoice Number: INV-874592
- Date of Issue: August 15, 2055
- Overcharged Amount: $72.50

I kindly request that you <mark>investigate</mark> this matter and provide clarification on the charges. Additionally, I would appreciate a prompt adjustment to my account to reflect the correct billing amount.

Thank you for addressing this issue. I look forward to your <mark>swift</mark> response and resolution. Please feel free to contact me at emily.choi@email.com or (646) 555-1942 to discuss this matter further.

Sincerely,

Emily Choi`,
  translation: `제목: 계정 과다 청구에 관한 우려

친애하는 청구 부서에게,

이 메시지가 귀하께 잘 전달되기를 바랍니다. 저는 최근 제 계정에서 발생한 과다 청구 문제에 관한 우려를 표현하고자 이 글을 씁니다. 이 상황은 예상치 못한 불편을 초래했으며, 신속하게 해결되기를 간절히 바랍니다.

최근 청구 명세서를 검토하던 중, 제공된 서비스와 일치하지 않는 불일치를 발견했습니다. 합의된 금액을 초과하는 요금이 청구되는 실수가 발생했다고 생각합니다. 참고를 위해, 다음은 과다 청구된 인보이스의 세부 정보입니다:

- 인보이스 번호: INV-874592
- 발행일: 2055년 8월 15일
- 과다 청구 금액: $72.50

이 문제를 조사하고 요금에 대한 설명을 제공해 주시기를 정중히 요청합니다. 또한, 정확한 청구 금액을 반영하도록 제 계정을 신속하게 조정해 주시면 감사하겠습니다.

이 문제를 처리해 주셔서 감사합니다. 신속한 응답과 해결을 기대합니다. 이 문제에 대해 더 논의하시려면 emily.choi@email.com 또는 (646) 555-1942로 언제든지 연락해 주십시오.

감사합니다,

Emily Choi`,
  koreanNouns: `Subject: Concern Regarding Account Overcharge

Dear Billing Department,

I hope this message finds you well. I am writing to express my concern regarding a recent issue I encountered with an overcharge on my account. This situation has caused unexpected inconvenience, and I am eager to have it resolved promptly.

Upon reviewing my recent <mark>청구 명세서</mark>, I noticed <mark>불일치</mark> that do not align with the services provided. I believe a mistake has occurred, which resulted in a charge exceeding the <mark>합의된 금액</mark>. For your reference, here are the details of the overcharged invoice:

- Invoice Number: INV-874592
- Date of Issue: August 15, 2055
- Overcharged Amount: $72.50

I kindly request that you <mark>조사하다</mark> this matter and provide clarification on the charges. Additionally, I would appreciate a prompt adjustment to my account to reflect the correct billing amount.

Thank you for addressing this issue. I look forward to your <mark>신속한</mark> response and resolution. Please feel free to contact me at emily.choi@email.com or (646) 555-1942 to discuss this matter further.

Sincerely,

Emily Choi`,
  wordPairs: {
    "billing statement": "청구 명세서",
    discrepancies: "불일치",
    "agreed-upon amount": "합의된 금액",
    investigate: "조사하다",
    swift: "신속한",
  },
  questions: [],
};

export const customerEmailQuestions = [
  email1,
  email2,
  email3,
  email4,
  email5,
  email6,
  email7,
  {
    id: 8,
    passage: `Subject: Your Order Has Been Fully Delivered – Thank You for Choosing Us

Dear GreenTech Industries, Inc.,

We're pleased to inform you that your full order placed on August 22, 2055 has now been completely delivered. Thank you once again for trusting SwiftSupply Solutions for your workplace <mark>furnishing</mark> needs.

Here's a detailed update on your order's progress:

The 50 Ergonomic Office Chairs were successfully delivered on August 28, and confirmed by your reception team. Our logistics team ensured that all chairs arrived fully packaged with assembly guides included.

The 25 Adjustable Standing Desks were delivered on August 29, and our records confirm the packages were received in good condition. If you <mark>opted</mark> for assembly service, a separate team will be contacting you shortly to schedule setup.

Finally, the 10 Wireless Conference Speakerphones were delivered on August 30, completing the final shipment in your order. Each unit was pre-tested before shipping to ensure functionality.

We've verified that all three shipments were successfully received at your delivery address:
1024 Innovation Avenue, Suite 500, Silicon Valley, CA 94043.

If you notice any missing or damaged items, or require additional support—such as assembly assistance, bulk re-orders, or product documentation—please let us know right away. We're here to help.

Your invoice and official delivery receipt will be emailed to your billing contact within the next 24 hours. Warranty information and product manuals can also be accessed through your customer dashboard.

Should you have any questions or need anything further, please don't hesitate to reach out to us directly at support@swiftsupply.com or (800) 555-8420. You can also contact your dedicated account manager, Linda Choi, at linda.choi@swiftsupply.com.

We're truly grateful for the opportunity to serve your team, and we look forward to working with you again soon.

Warm regards,
Customer Service Team
SwiftSupply Solutions`,
    translation: `제목: 주문이 완전히 배송되었습니다 – 저희를 선택해 주셔서 감사합니다

친애하는 GreenTech Industries, Inc. 귀하,

2055년 8월 22일에 주문하신 모든 물품이 이제 완전히 배송되었음을 알려드립니다. 직장 가구 필요를 위해 SwiftSupply Solutions를 신뢰해 주셔서 다시 한번 감사드립니다.

다음은 주문 진행 상황에 대한 자세한 업데이트입니다:

50개의 인체공학적 사무용 의자는 8월 28일에 성공적으로 배송되었으며, 귀사의 접수팀에 의해 확인되었습니다. 저희 물류팀은 모든 의자가 조립 가이드와 함께 완전히 포장되어 도착했음을 확인했습니다.

25개의 조절 가능한 스탠딩 데스크는 8월 29일에 배송되었으며, 저희 기록에 따르면 패키지가 양호한 상태로 수령되었습니다. 조립 서비스를 선택하셨다면, 별도의 팀이 곧 설치 일정을 잡기 위해 연락드릴 것입니다.

마지막으로, 10개의 무선 회의용 스피커폰이 8월 30일에 배송되어 주문의 마지막 배송이 완료되었습니다. 각 기기는 배송 전에 기능을 확인하기 위해 사전 테스트되었습니다.

세 번의 배송 모두 다음 배송 주소로 성공적으로 수령되었음을 확인했습니다:
1024 Innovation Avenue, Suite 500, Silicon Valley, CA 94043.

누락되거나 손상된 물품이 있거나, 조립 지원, 대량 재주문 또는 제품 문서와 같은 추가 지원이 필요하시면 즉시 알려주십시오. 저희가 도와드리겠습니다.

청구서와 공식 배송 영수증은 24시간 이내에 귀하의 청구 담당자에게 이메일로 발송될 예정입니다. 보증 정보와 제품 매뉴얼도 고객 대시보드를 통해 접근하실 수 있습니다.

질문이 있으시거나 추가 도움이 필요하시면 support@swiftsupply.com 또는 (800) 555-8420으로 직접 연락해 주십시오. 또한 전담 계정 관리자인 Linda Choi에게 linda.choi@swiftsupply.com으로 연락하실 수도 있습니다.

귀사를 섬길 수 있는 기회에 진심으로 감사드리며, 곧 다시 함께 일할 수 있기를 기대합니다.

감사합니다,
고객 서비스 팀
SwiftSupply Solutions`,
    koreanNouns: `Subject: Your Order Has Been Fully Delivered – Thank You for Choosing Us

Dear GreenTech Industries, Inc.,

We're pleased to inform you that your full order placed on August 22, 2055 has now been completely delivered. Thank you once again for trusting SwiftSupply Solutions for your workplace <mark>가구 비치</mark> needs.

Here's a detailed update on your order's progress:

The 50 Ergonomic Office Chairs were successfully delivered on August 28, and confirmed by your reception team. Our logistics team ensured that all chairs arrived fully packaged with assembly guides included.

The 25 Adjustable Standing Desks were delivered on August 29, and our records confirm the packages were received in good condition. If you <mark>선택했다</mark> for assembly service, a separate team will be contacting you shortly to schedule setup.

Finally, the 10 Wireless Conference Speakerphones were delivered on August 30, completing the final shipment in your order. Each unit was pre-tested before shipping to ensure functionality.

We've verified that all three shipments were successfully received at your delivery address:
1024 Innovation Avenue, Suite 500, Silicon Valley, CA 94043.

If you notice any missing or damaged items, or require additional support—such as assembly assistance, bulk re-orders, or product documentation—please let us know right away. We're here to help.

Your invoice and official delivery receipt will be emailed to your billing contact within the next 24 hours. Warranty information and product manuals can also be accessed through your customer dashboard.

Should you have any questions or need anything further, please don't hesitate to reach out to us directly at support@swiftsupply.com or (800) 555-8420. You can also contact your dedicated account manager, Linda Choi, at linda.choi@swiftsupply.com.

We're truly grateful for the opportunity to serve your team, and we look forward to working with you again soon.

Warm regards,
Customer Service Team
SwiftSupply Solutions`,
    wordPairs: {
      furnishing: "가구 비치",
      opted: "선택했다",
    },
    questions: [],
  },

  {
    id: 9,
    passage: `Subject: Inquiry About Additional Office Furniture Order

Dear Ms. Hartwell,

I hope this message finds you well. I am writing to discuss the possibility of placing an additional order for office furniture for our company, BrightCore Technologies. Based on our current needs and several upcoming internal projects, we have determined that further <mark>enhancements</mark> to our office setup are necessary.

List of Required Furniture

We would like to request the following items:

Office Desks: 10 units
<mark>Ergonomic</mark> Chairs: 15 units
Filing Cabinets: 5 units
Conference Tables: 2 units
Bookshelves: 3 units

Specifications and Preferences

To ensure visual consistency and functionality within our workspace, we would appreciate it if the following preferences could be <mark>taken into account</mark>:

Desks and bookshelves in a light oak <mark>finish</mark>
Ergonomic chairs with <mark>adjustable</mark> height and lumbar support
Filing cabinets featuring lockable drawers
Conference tables equipped with cable management features

Timeline and Delivery

If possible, we would like the delivery to be scheduled within the next 4 weeks, ideally no later than April 21, 2025, to allow us <mark>ample</mark> time for installation before a series of planned meetings and <mark>onboarding sessions</mark>.

Conclusion

Thank you for your attention to this matter. We look forward to your prompt response and hope to proceed smoothly with this additional order. If you require any further details or clarification, please do not hesitate to contact me directly.

Warm regards,
Ethan Cho
Operations Manager
BrightCore Technologies`,
    translation: `제목: 추가 사무용 가구 주문 문의

Hartwell 님께,

안녕하세요. 저희 회사 BrightCore Technologies의 추가 사무용 가구 주문 가능성에 대해 논의하고자 이 메시지를 보냅니다. 현재 필요와 여러 예정된 내부 프로젝트를 기반으로, 저희 사무실 설비에 추가적인 개선이 필요하다고 판단했습니다.

필요한 가구 목록

다음 품목을 요청하고자 합니다:

사무용 책상: 10개
인체공학적 의자: 15개
서류 캐비닛: 5개
회의 테이블: 2개
책장: 3개
사양 및 선호 사항

작업 공간 내 시각적 일관성과 기능성을 보장하기 위해 다음 선호 사항을 고려해 주시면 감사하겠습니다:

책상과 책장은 밝은 오크 마감
인체공학적 의자는 높이 조절 및 요추 지지대 포함
서류 캐비닛은 잠금 가능한 서랍 특징
회의 테이블은 케이블 관리 기능 장착

일정 및 배송
가능하다면, 예정된 회의 및 온보딩 세션 전에 설치할 충분한 시간을 확보하기 위해 향후 4주 이내, 이상적으로는 2025년 4월 21일까지 배송이 예약되기를 희망합니다.

결론
이 문제에 대한 관심에 감사드립니다. 귀하의 신속한 답변을 기대하며 이 추가 주문이 원활하게 진행되기를 바랍니다. 추가 세부 정보나 명확한 설명이 필요하시면 언제든지 저에게 직접 연락해 주십시오.

감사합니다,
Ethan Cho
운영 관리자
BrightCore Technologies`,
    koreanNouns: `Subject: Inquiry About Additional Office Furniture Order

Dear Ms. Hartwell,

I hope this message finds you well. I am writing to discuss the possibility of placing an additional order for office furniture for our company, BrightCore Technologies. Based on our current needs and several upcoming internal projects, we have determined that further <mark>개선</mark> to our office setup are necessary.

List of Required Furniture

We would like to request the following items:

Office Desks: 10 units
<mark>인체공학적</mark> Chairs: 15 units
Filing Cabinets: 5 units
Conference Tables: 2 units
Bookshelves: 3 units

Specifications and Preferences

To ensure visual consistency and functionality within our workspace, we would appreciate it if the following preferences could be <mark>고려하다</mark>:

Desks and bookshelves in a light oak <mark>마감</mark>
Ergonomic chairs with <mark>조절가능한</mark> height and lumbar support
Filing cabinets featuring lockable drawers
Conference tables equipped with cable management features

Timeline and Delivery

If possible, we would like the delivery to be scheduled within the next 4 weeks, ideally no later than April 21, 2025, to allow us <mark>충분한</mark> time for installation before a series of planned meetings and <mark>신입교육세션</mark>.

Conclusion

Thank you for your attention to this matter. We look forward to your prompt response and hope to proceed smoothly with this additional order. If you require any further details or clarification, please do not hesitate to contact me directly.

Warm regards,
Ethan Cho
Operations Manager
BrightCore Technologies`,
    wordPairs: {
      enhancements: "개선",
      Ergonomic: "인체공학적",
      "taken into account": "고려하다",
      finish: "마감",
      adjustable: "조절가능한",
      ample: "충분한",
      "onboarding sessions": "신입교육세션",
    },
    questions: [],
  },

  {
    id: 10,
    passage: `Subject: Order Inquiry for Additional Products – Order #12345

Dear Customer Service Team,

I hope this email finds you well. I recently received my order and was extremely satisfied with the product. The quality and performance of the item <mark>surpassed</mark> my expectations, and I am eager to place an additional order.

The product I originally ordered is the "LuminaPro Desk Lamp." I would like to order an additional 5 units of this product. Please <mark>refer</mark> to my previous order number: #12345 for your records.

I would appreciate it if you could process this order <mark>swiftly</mark>, as I am <mark>keen</mark> to receive the products at your earliest possible convenience. If you require any further information to facilitate this process, please do not hesitate to contact me.

Thank you for your prompt attention to this order. I look forward to hearing from you soon.

Best regards,

Samantha Lee`,
    translation: `제목: 추가 제품 주문 문의 - 주문 번호 #12345

고객 서비스팀께,

이 이메일이 귀하께 잘 전달되기를 바랍니다. 최근에 제 주문을 받았으며 제품에 매우 만족했습니다. 제품의 품질과 성능이 제 기대를 뛰어넘었으며, 추가 주문을 하고 싶습니다.

제가 원래 주문한 제품은 "LuminaPro 데스크 램프"입니다. 이 제품을 추가로 5개 주문하고 싶습니다. 기록을 위해 이전 주문 번호 #12345를 참조해 주세요.

가능한 빨리 제품을 받고 싶으니 이 주문을 신속하게 처리해 주시면 감사하겠습니다. 이 과정을 원활하게 진행하기 위해 추가 정보가 필요하시면 언제든지 저에게 연락해 주십시오.

이 주문에 신속하게 주의를 기울여 주셔서 감사합니다. 곧 소식을 듣기를 기대합니다.

감사합니다,

사만다 리`,
    koreanNouns: `Subject: Order Inquiry for Additional Products – Order #12345

Dear Customer Service Team,

I hope this email finds you well. I recently received my order and was extremely satisfied with the product. The quality and performance of the item <mark>뛰어넘다</mark> my expectations, and I am eager to place an additional order.

The product I originally ordered is the "LuminaPro Desk Lamp." I would like to order an additional 5 units of this product. Please <mark>참조하다</mark> to my previous order number: #12345 for your records.

I would appreciate it if you could process this order <mark>신속하게</mark>, as I am <mark>간절히 바라는</mark> to receive the products at your earliest possible convenience. If you require any further information to facilitate this process, please do not hesitate to contact me.

Thank you for your prompt attention to this order. I look forward to hearing from you soon.

Best regards,

Samantha Lee`,
    wordPairs: {
      surpassed: "뛰어넘다",
      refer: "참조하다",
      swiftly: "신속하게",
      keen: "간절히 바라는",
    },
    questions: [],
  },

  {
    id: 11,
    passage: `Subject: Upcoming Cleaning Service Notification – [March 27, 2025]

Dear Valued Customer,

We are pleased to inform you that your scheduled home cleaning service is approaching. To ensure a smooth and efficient experience, please review the following preparation checklist before our team arrives.

Preparation Checklist
- Remove any <mark>fragile</mark> or <mark>valuable</mark> items from the areas to be cleaned.
- Ensure easy access to all rooms and surfaces by tidying up clutter.
- If you have pets, please <mark>secure</mark> them in a safe space to minimize disturbance.
- If there are updated <mark>entry instructions</mark> (e.g., door codes or key location), kindly provide them in advance.

What to Expect
Our professional cleaning team will arrive <mark>promptly</mark> at your scheduled time on March 27, 2025 at 10:00 AM.

They will bring all the necessary supplies and equipment and follow your cleaning preferences, including any specific areas of focus you've previously mentioned.

Contact Information
If you have any questions, changes to your schedule, or additional requests, feel free to reach out to us:
📧 support@freshnestcleaning.com
📞 (800) 123-4567


We look forward to leaving your home sparkling clean and comfortable.

Thank you for choosing FreshNest Cleaning Services.

Best regards,

Customer Care Team
FreshNest Cleaning Services`,
    translation: `제목: 예정된 청소 서비스 알림 – [2025년 3월 27일]

고객님께,

예정된 가정 청소 서비스가 다가오고 있음을 알려드립니다. 원활하고 효율적인 경험을 보장하기 위해, 저희 팀이 도착하기 전에 다음 준비 체크리스트를 검토해 주시기 바랍니다.

### 준비 체크리스트

- 청소할 구역에서 깨지기 쉽거나 귀중한 물품을 치워주세요.
- 물건을 정리하여 모든 방과 표면에 쉽게 접근할 수 있도록 해주세요.
- 반려동물이 있으시다면, 방해를 최소화하기 위해 안전한 공간에 보관해 주세요.
- 출입 지침이 업데이트되었다면(예: 도어 코드 또는 열쇠 위치), 미리 알려주시기 바랍니다.

### 예상되는 사항

저희 전문 청소 팀은 2025년 3월 27일 오전 10시에 예정된 시간에 정확히 도착할 것입니다.

그들은 필요한 모든 용품과 장비를 가져오고 이전에 언급하신 특정 집중 영역을 포함한 귀하의 청소 선호도를 따를 것입니다.

연락처 정보

질문, 일정 변경 또는 추가 요청이 있으시면 언제든지 연락 주세요:

📧 support@freshnestcleaning.com

📞 (800) 123-4567

---

귀하의 집을 반짝반짝 깨끗하고 편안하게 만들어 드리기를 기대합니다.

FreshNest 청소 서비스를 선택해 주셔서 감사합니다.

감사합니다,

고객 관리 팀

FreshNest 청소 서비스`,
    koreanNouns: `Subject: Upcoming Cleaning Service Notification – [March 27, 2025]

Dear Valued Customer,

We are pleased to inform you that your scheduled home cleaning service is approaching. To ensure a smooth and efficient experience, please review the following preparation checklist before our team arrives.

Preparation Checklist
- Remove any <mark>깨지기 쉬운</mark> or <mark>귀중한</mark> items from the areas to be cleaned.
- Ensure easy access to all rooms and surfaces by tidying up clutter.
- If you have pets, please <mark>안전한</mark> them in a safe space to minimize disturbance.
- If there are updated <mark>출입 지침</mark> (e.g., door codes or key location), kindly provide them in advance.

What to Expect
Our professional cleaning team will arrive <mark>정확히</mark> at your scheduled time on March 27, 2025 at 10:00 AM.

They will bring all the necessary supplies and equipment and follow your cleaning preferences, including any specific areas of focus you've previously mentioned.

Contact Information
If you have any questions, changes to your schedule, or additional requests, feel free to reach out to us:
📧 support@freshnestcleaning.com
📞 (800) 123-4567


We look forward to leaving your home sparkling clean and comfortable.

Thank you for choosing FreshNest Cleaning Services.

Best regards,

Customer Care Team
FreshNest Cleaning Services`,
    wordPairs: {
      fragile: "깨지기 쉬운",
      valuable: "귀중한",
      secure: "안전한",
      "entry instructions": "출입 지침",
      promptly: "정확히",
    },
    questions: [],
  },
  {
    id: 12,
    passage: `Subject: VIP Program Points System - Your Comprehensive Guide

Dear Valued VIP Customer,

We are thrilled to have you as a part of our exclusive VIP program. As a <mark>distinguished</mark> member, you enjoy numerous benefits, including our rewarding points system. This letter aims to provide you with detailed information about how our points system works and how you can maximize your rewards.

How to Earn Points
As a VIP cardholder, you can earn points on every <mark>transaction</mark> made with your card. These points can be accumulated and later <mark>redeemed</mark> for a wide range of rewards. Here's how you can earn points:

- Earn 1 point for every $10 spent on <mark>eligible</mark> purchases.
- Receive additional bonus points during promotional periods.
- Earn double points on your birthday month.

Redeeming Your Points
Once you have accumulated enough points, you can choose to redeem them for various exciting rewards. Below is a list of options available to you:

- Gift vouchers for leading retail stores.
- Dining discounts at select partner restaurants.
- Exclusive access to special events and experiences.

Checking Your Points Balance
To stay updated on your points balance, you can:
1. Log into your online account on our website.
2. View your balance on the monthly statements we send.
3. Contact our customer service team for assistance.

Contact Us
If you have any questions regarding your points or need further assistance, please do not hesitate to reach out to our <mark>dedicated</mark> VIP team. We are here to ensure you have the best experience as our <mark>esteemed</mark> VIP cardholder.

Thank you for choosing us and being a part of our community. We look forward to continuing to serve you with excellence and reward you <mark>generously</mark> for your loyalty.

Sincerely,

Your VIP Program Team`,
    translation: `제목: VIP 프로그램 포인트 시스템 - 종합 안내

존경하는 VIP 고객님께,

귀하를 저희 독점 VIP 프로그램의 일원으로 모시게 되어 기쁩니다. 저희의 특별한 회원으로서, 귀하는 보상 포인트 시스템을 포함한 다양한 혜택을 누리실 수 있습니다. 이 안내문은 저희 포인트 시스템의 작동 방식과 보상을 최대화하는 방법에 대한 자세한 정보를 제공하고자 합니다.

포인트 적립 방법
VIP 카드 소지자로서, 귀하는 카드로 이루어진 모든 거래에서 포인트를 적립할 수 있습니다. 이 포인트는 누적되어 나중에 다양한 보상으로 교환할 수 있습니다. 다음은 포인트를 적립하는 방법입니다:

- 적격 구매 시 $10마다 1포인트 적립.
- 프로모션 기간 동안 추가 보너스 포인트 획득.
- 생일이 있는 달에는 포인트 두 배 적립.

포인트 사용하기
충분한 포인트를 모으면, 다양한 흥미로운 보상으로 교환할 수 있습니다. 다음은 귀하가 이용할 수 있는 옵션 목록입니다:

- 주요 소매점의 상품권.
- 선정된 파트너 레스토랑에서의 식사 할인.
- 특별 이벤트 및 경험에 대한 독점 접근.

포인트 잔액 확인하기
포인트 잔액을 최신 상태로 유지하기 위해 다음과 같은 방법을 이용할 수 있습니다:
1. 저희 웹사이트에서 온라인 계정에 로그인.
2. 저희가 보내드리는 월별 명세서에서 잔액 확인.
3. 도움이 필요하시면 고객 서비스 팀에 문의.

연락처
포인트에 관한 질문이 있거나 추가 도움이 필요하시면, 저희 전담 VIP 팀에 연락하시기 바랍니다. 저희는 귀하께서 저희의 존경받는 VIP 카드 소지자로서 최고의 경험을 하실 수 있도록 항상 준비되어 있습니다.

저희를 선택해 주시고 저희 커뮤니티의 일원이 되어 주셔서 감사합니다. 앞으로도 계속해서 귀하께 탁월한 서비스를 제공하고 충성도에 대해 관대하게 보상해 드리기를 기대합니다.

감사합니다,

VIP 프로그램 팀`,
    koreanNouns: `Subject: VIP Program Points System - Your Comprehensive Guide

Dear Valued VIP Customer,

We are thrilled to have you as a part of our exclusive VIP program. As a <mark>특별한</mark> member, you enjoy numerous benefits, including our rewarding points system. This letter aims to provide you with detailed information about how our points system works and how you can maximize your rewards.

How to Earn Points
As a VIP cardholder, you can earn points on every <mark>거래</mark> made with your card. These points can be accumulated and later <mark>교환했다</mark> for a wide range of rewards. Here's how you can earn points:

- Earn 1 point for every $10 spent on <mark>적격한</mark> purchases.
- Receive additional bonus points during promotional periods.
- Earn double points on your birthday month.

Redeeming Your Points
Once you have accumulated enough points, you can choose to redeem them for various exciting rewards. Below is a list of options available to you:

- Gift vouchers for leading retail stores.
- Dining discounts at select partner restaurants.
- Exclusive access to special events and experiences.

Checking Your Points Balance
To stay updated on your points balance, you can:
1. Log into your online account on our website.
2. View your balance on the monthly statements we send.
3. Contact our customer service team for assistance.

Contact Us
If you have any questions regarding your points or need further assistance, please do not hesitate to reach out to our <mark>전담의 </mark> VIP team. We are here to ensure you have the best experience as our <mark>소중한</mark> VIP cardholder.

Thank you for choosing us and being a part of our community. We look forward to continuing to serve you with excellence and reward you <mark>관대하게</mark> for your loyalty.

Sincerely,

Your VIP Program Team`,
    wordPairs: {
      distinguished: "특별한",
      transaction: "거래",
      redeemed: "교환했다",
      eligible: "적격한",
      dedicated: "전담의 ",
      esteemed: "소중한",
      generously: "관대하게",
    },
    questions: [],
  },
  {
    id: 13,
    passage: `Subject: Welcome to Our Elite Airline Membership Program

Dear Valued Member,

We are thrilled to have you with us! As a <mark>cherished</mark> member of our airline, you are entitled to a range of exclusive benefits designed to enhance your travel experience. Discover the <mark>perks</mark> awaiting you:

Premium Benefits

As part of our membership program, enjoy:

- Priority <mark>Boarding</mark>: Experience the convenience of boarding the plane ahead of others.
- Lounge Access: Relax in luxury before your flights with <mark>complimentary</mark> access to our exclusive lounges.
- Extra <mark>Baggage Allowance</mark>: Travel without worries with additional baggage capacity.

Exclusive Discounts

Save on your travels with these exclusive offers:

- Fare Discounts: Receive up to 20% off on select flights.
- Partner Discounts: Enjoy special rates at partner hotels and car rentals.

Personalized Services

We aim to make your journey <mark>seamless</mark> with our <mark>personalized</mark> services:

- Dedicated Customer Support: Access priority support for all your inquiries and bookings.
- Customized Travel Plans: Get <mark>tailored</mark> travel recommendations and <mark>itineraries</mark>.

Join Our Events

Be part of our community by attending exclusive member events:

- Invitation to Members-Only <mark>Gatherings</mark>: Network with fellow members and industry experts.
- Access to Annual Gala: Celebrate with us at our annual member gala.

We look forward to serving you and making your journeys more enjoyable. Thank you for choosing our airline for your travel needs!

Safe travels,

Your Airline Membership Team`,
    translation: `제목: 엘리트 항공사 멤버십 프로그램에 오신 것을 환영합니다

존경하는 회원님께,

저희와 함께하게 되어 매우 기쁩니다! 저희 항공사의 소중한 회원으로서, 귀하는 여행 경험을 향상시키기 위해 설계된 다양한 독점 혜택을 받으실 수 있습니다. 귀하를 기다리고 있는 특전을 확인해 보세요:

프리미엄 혜택

멤버십 프로그램의 일환으로 다음을 즐기세요:

- 우선 탑승: 다른 승객보다 먼저 비행기에 탑승하는 편리함을 경험하세요.
- 라운지 이용: 무료로 제공되는 독점 라운지에서 비행 전 럭셔리한 휴식을 취하세요.
- 추가 수하물 허용량: 추가 수하물 용량으로 걱정 없이 여행하세요.

독점 할인

다음과 같은 독점 혜택으로 여행 비용을 절약하세요:

- 항공권 할인: 선택된 항공편에 대해 최대 20% 할인을 받으세요.
- 파트너 할인: 제휴 호텔 및 렌터카에서 특별 요금을 즐기세요.

맞춤형 서비스

저희는 맞춤형 서비스로 귀하의 여정을 원활하게 만들기 위해 노력합니다:

- 전담 고객 지원: 모든 문의 및 예약에 대한 우선 지원을 이용하세요.
- 맞춤형 여행 계획: 맞춤형 여행 추천 및 일정을 받으세요.

이벤트 참여

독점 회원 이벤트에 참여하여 저희 커뮤니티의 일원이 되세요:

- 회원 전용 모임 초대: 다른 회원 및 업계 전문가와 네트워킹하세요.
- 연례 갈라 행사 참석: 연례 회원 갈라에서 저희와 함께 축하하세요.

귀하에게 서비스를 제공하고 여정을 더욱 즐겁게 만들기를 기대합니다. 여행 필요에 저희 항공사를 선택해 주셔서 감사합니다!

안전한 여행 되세요,

항공사 멤버십 팀`,
    koreanNouns: `Subject: Welcome to Our Elite Airline Membership Program

Dear Valued Member,

We are thrilled to have you with us! As a <mark>소중한</mark> member of our airline, you are entitled to a range of exclusive benefits designed to enhance your travel experience. Discover the <mark>혜택</mark> awaiting you:

Premium Benefits

As part of our membership program, enjoy:

- Priority <mark>탑승</mark>: Experience the convenience of boarding the plane ahead of others.
- Lounge Access: Relax in luxury before your flights with <mark>무료의</mark> access to our exclusive lounges.
- Extra <mark>수하물 허용량</mark>: Travel without worries with additional baggage capacity.

Exclusive Discounts

Save on your travels with these exclusive offers:

- Fare Discounts: Receive up to 20% off on select flights.
- Partner Discounts: Enjoy special rates at partner hotels and car rentals.

Personalized Services

We aim to make your journey <mark>원활하게</mark> with our <mark>맞춤화된</mark> services:

- Dedicated Customer Support: Access priority support for all your inquiries and bookings.
- Customized Travel Plans: Get <mark>맞춤화된</mark> travel recommendations and <mark>일정</mark>.

Join Our Events

Be part of our community by attending exclusive member events:

- Invitation to Members-Only <mark>모임</mark>: Network with fellow members and industry experts.
- Access to Annual Gala: Celebrate with us at our annual member gala.

We look forward to serving you and making your journeys more enjoyable. Thank you for choosing our airline for your travel needs!

Safe travels,

Your Airline Membership Team`,
    wordPairs: {
      cherished: "소중한",
      perks: "혜택",
      Boarding: "탑승",
      complimentary: "무료의",
      "Baggage Allowance": "수하물 허용량",
      seamless: "원활하게",
      personalized: "맞춤화된",
      tailored: "맞춤화된",
      itineraries: "일정",
      Gatherings: "모임",
    },
    questions: [],
  },

  {
    id: 14,
    passage: `Subject: Your Dream Home Has Been Found – 482 Maplewood Lane

Dear Mr. Thompson,

I hope this message finds you well. I am excited to inform you that we have successfully found a property that matches your desired home specifications. We understand how important this decision is for you, and we have carefully selected a property that aligns with your preferences.

The property located at 482 Maplewood Lane, Brookfield Heights aligns perfectly with the <mark>criteria</mark> you <mark>outlined</mark>. With its <mark>inviting</mark> layout, modern features, and prime location, it promises to be the ideal home you've been seeking.

Here are some key features of the property:
<mark>Spacious</mark> and sunlit living areas with hardwood floors
A modern kitchen equipped with stainless steel appliances and <mark>granite</mark> <mark>countertops</mark>
A beautifully landscaped garden with a private patio
Walking distance to schools, shopping centers, and public transportation
A secure and family-friendly neighborhood

We truly believe that this home captures everything you <mark>envisioned</mark>—and possibly more.

Please let me know a convenient time for you to schedule a viewing, or if you have any questions or need further information. I'll be happy to assist you at every step of the process.

Looking forward to hearing from you soon!

Best regards,
Emily Chen`,
    translation: `제목: 귀하의 꿈의 집을 찾았습니다 – 482 Maplewood Lane

Thompson 님께,

안녕하세요. 귀하가 원하시는 집 사양에 맞는 부동산을 성공적으로 찾았다는 소식을 알려드리게 되어 기쁩니다. 이 결정이 귀하에게 얼마나 중요한지 이해하고 있으며, 귀하의 선호도에 맞는 부동산을 신중하게 선정했습니다.

Brookfield Heights의 482 Maplewood Lane에 위치한 이 부동산은 귀하가 제시한 기준과 완벽하게 일치합니다. 초대하는 듯한 구조, 현대적인 특징, 그리고 최고의 위치를 갖춘 이 집은 귀하가 찾고 계시던 이상적인 집이 될 것입니다.

다음은 이 부동산의 주요 특징입니다:

원목 바닥이 깔린 넓고 햇빛이 잘 드는 거실 공간

스테인리스 스틸 가전제품과 화강암 조리대를 갖춘 현대적인 주방

아름답게 조경된 정원과 개인 파티오

학교, 쇼핑 센터, 대중교통까지 도보 거리

안전하고 가족 친화적인 동네

저희는 이 집이 귀하가 구상하신 모든 것을 담고 있다고 진심으로 믿습니다—아마도 그 이상일 것입니다.

편하신 시간에 집을 둘러보실 일정을 잡아주시거나, 질문이 있으시거나 추가 정보가 필요하시면 알려주세요. 과정의 모든 단계에서 기꺼이 도와드리겠습니다.

곧 연락 주시기를 기대합니다!

감사합니다,
Emily Chen`,
    koreanNouns: `Subject: Your Dream Home Has Been Found – 482 Maplewood Lane

Dear Mr. Thompson,

I hope this message finds you well. I am excited to inform you that we have successfully found a property that matches your desired home specifications. We understand how important this decision is for you, and we have carefully selected a property that aligns with your preferences.

The property located at 482 Maplewood Lane, Brookfield Heights aligns perfectly with the <mark>기준</mark> you <mark>제시한</mark>. With its <mark>매력적인</mark> layout, modern features, and prime location, it promises to be the ideal home you've been seeking.

Here are some key features of the property:
<mark>넓은</mark> and sunlit living areas with hardwood floors
A modern kitchen equipped with stainless steel appliances and <mark>화강암</mark> <mark>조리대</mark>
A beautifully landscaped garden with a private patio
Walking distance to schools, shopping centers, and public transportation
A secure and family-friendly neighborhood

We truly believe that this home captures everything you <mark>구상한</mark>—and possibly more.

Please let me know a convenient time for you to schedule a viewing, or if you have any questions or need further information. I'll be happy to assist you at every step of the process.

Looking forward to hearing from you soon!

Best regards,
Emily Chen`,
    wordPairs: {
      criteria: "기준",
      outlined: "제시한",
      inviting: "매력적인",
      Spacious: "넓은",
      granite: "화강암",
      countertops: "조리대",
      envisioned: "구상한",
    },
    questions: [],
  },

  {
    id: 15,
    passage: `Subject: Request for <mark>bulk order</mark> – Office Supplies

Dear Mr. Turner,

I hope this message finds you well. I am writing to inquire about the possibility of placing a bulk order with your company. We have been impressed with the quality and <mark>durability</mark> of your office supply products and are considering a significant purchase for our new branch opening.

Order Details
We are interested in the following items:

ErgoFlex Mesh Office Chair – Quantity: 100 units
SmartDesk Pro Adjustable Standing Desk – Quantity: 200 units
UltraBright LED Desk Lamp (White) – Quantity: 150 units

Could you please provide us with the pricing details for the quantities listed above? Additionally, we would like to understand the <mark>lead time</mark>, and whether any volume-based discounts or promotional offers are available.

Shipping and Delivery
Our <mark>preferred</mark> delivery date is April 15, 2025. Please let us know if this timeline is <mark>feasible</mark> and if there are any additional shipping costs we should <mark>be aware of</mark> for delivery to our New York headquarters.

Payment Terms
We would appreciate it if you could share the payment terms and conditions <mark>applicable</mark> to bulk orders. This will assist our finance team in processing approvals accordingly.

Thank you for your attention to this inquiry. We look forward to your prompt response and hope to build a long-term partnership with your company.

Sincerely,
BrightEdge Solutions`,
    translation: `제목: 대량 주문 요청 – 사무용품

친애하는 Turner 님께,

안녕하세요. 귀사에 대량 주문을 할 가능성에 대해 문의드리고자 이 메일을 보냅니다. 저희는 귀사의 사무용품 제품의 품질과 내구성에 감명을 받았으며, 새로운 지점 개설을 위해 상당한 구매를 고려하고 있습니다.

주문 세부 사항
저희는 다음 품목에 관심이 있습니다:

ErgoFlex 메쉬 사무용 의자 – 수량: 100개

SmartDesk Pro 조절식 스탠딩 데스크 – 수량: 200개

UltraBright LED 데스크 램프 (화이트) – 수량: 150개

위에 나열된 수량에 대한 가격 정보를 제공해 주시겠습니까? 또한, 납품 소요 시간과 수량 기반 할인 또는 프로모션 제안이 있는지 알고 싶습니다.

배송 및 배달
저희가 선호하는 배송 날짜는 2025년 4월 15일입니다. 이 일정이 실현 가능한지, 그리고 뉴욕 본사로의 배송에 대해 알아야 할 추가 배송 비용이 있는지 알려주시기 바랍니다.

지불 조건
대량 주문에 적용되는 지불 조건을 공유해 주시면 감사하겠습니다. 이는 저희 재무팀이 승인을 처리하는 데 도움이 될 것입니다.

이 문의에 주의를 기울여 주셔서 감사합니다. 신속한 응답을 기대하며, 귀사와 장기적인 파트너십을 구축하기를 희망합니다.

감사합니다,
BrightEdge Solutions`,
    koreanNouns: `Subject: Request for <mark>대량 주문</mark> – Office Supplies

Dear Mr. Turner,

I hope this message finds you well. I am writing to inquire about the possibility of placing a bulk order with your company. We have been impressed with the quality and <mark>내구성</mark> of your office supply products and are considering a significant purchase for our new branch opening.

Order Details
We are interested in the following items:

ErgoFlex Mesh Office Chair – Quantity: 100 units
SmartDesk Pro Adjustable Standing Desk – Quantity: 200 units
UltraBright LED Desk Lamp (White) – Quantity: 150 units

Could you please provide us with the pricing details for the quantities listed above? Additionally, we would like to understand the <mark>납품 소요 시간</mark>, and whether any volume-based discounts or promotional offers are available.

Shipping and Delivery
Our <mark>선호하는</mark> delivery date is April 15, 2025. Please let us know if this timeline is <mark>실현 가능한</mark> and if there are any additional shipping costs we should <mark>알다</mark> for delivery to our New York headquarters.

Payment Terms
We would appreciate it if you could share the payment terms and conditions <mark>적용되는</mark> to bulk orders. This will assist our finance team in processing approvals accordingly.

Thank you for your attention to this inquiry. We look forward to your prompt response and hope to build a long-term partnership with your company.

Sincerely,
BrightEdge Solutions`,
    wordPairs: {
      "bulk order": "대량 주문",
      durability: "내구성",
      "lead time": "납품 소요 시간",
      preferred: "선호하는",
      feasible: "실현 가능한",
      "be aware of": "알다",
      applicable: "적용되는",
    },
    questions: [],
  },

  {
    id: 16,
    passage: `Subject: Inquiry About Living Room Interior Design <mark>Cost Estimate</mark>

Dear Ms. Lauren Kim,

I hope this message finds you well. I am writing to inquire about the cost estimate for an interior design project, <mark>specifically</mark> for the living room area of my home. I have a few specific requirements that I would like to discuss, and I <mark>am keen to</mark> understand how these might affect the overall cost.

Here are some of the specific requirements I am considering for the living room design:

A modern and minimalist aesthetic with a neutral color palette
High-quality, sustainable materials for furniture and decor
Built-in storage solutions that maximize space efficiency
Advanced lighting systems with mood control settings

Could you please provide me with an estimate of the costs involved for such a project? Additionally, I would appreciate any recommendations you might have to <mark>optimize</mark> the budget while maintaining the quality and design <mark>integrity</mark> I am aiming for.

Thank you for your time and assistance. I look forward to your reply and discussing this project further.

Warm regards,
Daniel Yoon
daniel.yoon@email.com
(213) 555-9271`,
    translation: `제목: 거실 인테리어 디자인 비용 견적 문의

친애하는 Lauren Kim 님께,

안녕하세요. 저는 인테리어 디자인 프로젝트, 특히 제 집의 거실 공간에 대한 비용 견적을 문의드리고자 이 메일을 보냅니다. 논의하고 싶은 몇 가지 특정 요구 사항이 있으며, 이러한 요구 사항이 전체 비용에 어떤 영향을 미칠지 이해하고 싶습니다.

다음은 거실 디자인을 위해 고려하고 있는 몇 가지 특정 요구 사항입니다:

중립적인 색상 팔레트를 가진 현대적이고 미니멀한 미학

가구 및 장식용 고품질, 지속 가능한 소재

공간 효율성을 극대화하는 내장형 수납 솔루션

무드 제어 설정이 있는 고급 조명 시스템

이러한 프로젝트에 관련된 비용 견적을 제공해 주시겠습니까? 또한, 제가 목표로 하는 품질과 디자인 무결성을 유지하면서 예산을 최적화할 수 있는 추천 사항이 있으시면 감사하겠습니다.

시간과 도움에 감사드립니다. 귀하의 답변과 이 프로젝트에 대해 더 논의하기를 기대합니다.

따뜻한 인사를 보내며,
Daniel Yoon
daniel.yoon@email.com
(213) 555-9271`,
    koreanNouns: `Subject: Inquiry About Living Room Interior Design <mark>비용 견적</mark>

Dear Ms. Lauren Kim,

I hope this message finds you well. I am writing to inquire about the cost estimate for an interior design project, <mark>특히</mark> for the living room area of my home. I have a few specific requirements that I would like to discuss, and I <mark>간절이 원한다</mark> understand how these might affect the overall cost.

Here are some of the specific requirements I am considering for the living room design:

A modern and minimalist aesthetic with a neutral color palette
High-quality, sustainable materials for furniture and decor
Built-in storage solutions that maximize space efficiency
Advanced lighting systems with mood control settings

Could you please provide me with an estimate of the costs involved for such a project? Additionally, I would appreciate any recommendations you might have to <mark>최적화하다</mark> the budget while maintaining the quality and design <mark>무결성</mark> I am aiming for.

Thank you for your time and assistance. I look forward to your reply and discussing this project further.

Warm regards,
Daniel Yoon
daniel.yoon@email.com
(213) 555-9271`,
    wordPairs: {
      "cost estimate": "비용 견적",
      specifically: "특히",
      "am keen to": "간절이 원한다",
      optimize: "최적화하다",
      integrity: "무결성",
    },
    questions: [],
  },

  {
    id: 17,
    passage: `Subject: Inquiry About Meeting Room Rental and Services

Dear Ms. Rachel Monroe,

I hope this message finds you well. I am writing to inquire about the rental of your meeting rooms and the services included with the rental. We are planning a <mark>series of</mark> meetings next month and are considering utilizing your facilities.

Could you please provide us with detailed information on the following:

Services Included
Could you specify what services are included in the pricing for the meeting room rental? We are particularly interested in whether items such as <mark>audiovisual equipment</mark>, Wi-Fi/internet access, whiteboards or flipcharts, and refreshments are part of the package, or if they incur additional costs.

Rental Costs
We would appreciate it if you could share the pricing structure for the rental of your meeting spaces. If there are special rates for full-day bookings, <mark>recurring</mark> reservations, or <mark>nonprofit</mark> organizations, please let us know.

Booking and Cancellation Policies
Understanding your policies on booking, rescheduling, and cancellation will help us plan effectively. Please include details regarding any deposit requirements, minimum booking times, and how far in advance bookings must be made to ensure availability.

Thank you for your assistance. We look forward to your prompt response as we finalize arrangements for our upcoming events.

Best regards,
Kevin Lim
Operations Coordinator`,
    translation: `제목: 회의실 대여 및 서비스에 관한 문의

친애하는 레이첼 먼로 님께,

안녕하세요. 귀사의 회의실 대여 및 대여에 포함된 서비스에 대해 문의드립니다. 저희는 다음 달에 일련의 회의를 계획하고 있으며 귀사의 시설을 이용하는 것을 고려하고 있습니다.

다음 사항에 대한 자세한 정보를 제공해 주시겠습니까:

포함된 서비스
회의실 대여 가격에 어떤 서비스가 포함되어 있는지 명시해 주시겠습니까? 특히 시청각 장비, Wi-Fi/인터넷 접속, 화이트보드나 플립차트, 다과 등이 패키지에 포함되어 있는지, 아니면 추가 비용이 발생하는지에 관심이 있습니다.

대여 비용
회의 공간 대여에 대한 가격 구조를 공유해 주시면 감사하겠습니다. 종일 예약, 반복 예약 또는 비영리 단체를 위한 특별 요금이 있다면 알려주세요.

예약 및 취소 정책
예약, 일정 변경 및 취소에 관한 귀사의 정책을 이해하면 효과적으로 계획하는 데 도움이 될 것입니다. 보증금 요구 사항, 최소 예약 시간 및 가용성을 보장하기 위해 예약을 얼마나 미리 해야 하는지에 대한 세부 정보를 포함해 주세요.

도움에 감사드립니다. 다가오는 행사를 위한 준비를 마무리하는 동안 신속한 답변을 기대합니다.

감사합니다,
케빈 림
운영 코디네이터`,
    koreanNouns: `Subject: Inquiry About Meeting Room Rental and Services

Dear Ms. Rachel Monroe,

I hope this message finds you well. I am writing to inquire about the rental of your meeting rooms and the services included with the rental. We are planning a <mark>일련의</mark> meetings next month and are considering utilizing your facilities.

Could you please provide us with detailed information on the following:

Services Included
Could you specify what services are included in the pricing for the meeting room rental? We are particularly interested in whether items such as <mark>시청각 장비</mark>, Wi-Fi/internet access, whiteboards or flipcharts, and refreshments are part of the package, or if they incur additional costs.

Rental Costs
We would appreciate it if you could share the pricing structure for the rental of your meeting spaces. If there are special rates for full-day bookings, <mark>반복되는</mark> reservations, or <mark>비영리</mark> organizations, please let us know.

Booking and Cancellation Policies
Understanding your policies on booking, rescheduling, and cancellation will help us plan effectively. Please include details regarding any deposit requirements, minimum booking times, and how far in advance bookings must be made to ensure availability.

Thank you for your assistance. We look forward to your prompt response as we finalize arrangements for our upcoming events.

Best regards,
Kevin Lim
Operations Coordinator`,
    wordPairs: {
      recurring: "반복되는",
      nonprofit: "비영리",
      "series of": "일련의",
      "audiovisual equipment": "시청각 장비",
    },
    questions: [],
  },

  {
    id: 18,
    passage: `From: Michael Everett <michael.everett@greenlineindustries.com>
To: Juanita Wilson <jwilson@customwoodworks.com>
Subject: Custom Order Inquiry - Wooden Display Stands
Date: May 10, 2051

Dear Ms. Wilson,

I am writing to inquire about a custom order from your <mark>esteemed</mark> business. We need <mark>handcrafted</mark> wooden display stands, each designed to hold three 8x10 frames in a tiered layout, and would like to know if you can fulfill this request and, if so, what the cost and timeline would be.

Our business would require a quantity of 75 units to be delivered by June 15, 2051. Please let us know if this timeline is <mark>feasible</mark> on your end. Any additional details regarding shipping or handling would also be appreciated. We look forward to maintaining our business relationship with your esteemed organization and we trust that you will do your <mark>utmost</mark> to fulfill this request to our <mark>mutual</mark> satisfaction.

Please get back to me at your earliest convenience. It will be much appreciated if you can provide us with the cost estimate, payment terms, and any other pertinent information relevant to this custom order.

Thank you in advance for your attention to this matter.

Best regards,
Michael Everett`,
    translation: `보낸 사람: Michael Everett <michael.everett@greenlineindustries.com>
받는 사람: Juanita Wilson <jwilson@customwoodworks.com>
제목: 맞춤 주문 문의 - 목재 디스플레이 스탠드
날짜: 2051년 5월 10일

Wilson 님께,

귀사의 명성 높은 사업체에 맞춤 주문에 관해 문의드립니다. 저희는 3개의 8x10 프레임을 계단식 레이아웃으로 보관할 수 있는 수공예 목재 디스플레이 스탠드가 필요하며, 이 요청을 이행하실 수 있는지, 그리고 가능하다면 비용과 일정이 어떻게 되는지 알고 싶습니다.

저희 사업체는 2051년 6월 15일까지 75개 단위의 수량이 배송되어야 합니다. 이 일정이 귀하 측에서 실현 가능한지 알려주시기 바랍니다. 배송이나 취급에 관한 추가 세부 사항도 알려주시면 감사하겠습니다. 저희는 귀사와의 비즈니스 관계를 유지하기를 기대하며, 상호 만족을 위해 이 요청을 이행하기 위해 최선을 다해주실 것이라 믿습니다.

가능한 빨리 회신해 주시기 바랍니다. 비용 견적, 지불 조건 및 이 맞춤 주문과 관련된 기타 관련 정보를 제공해 주시면 대단히 감사하겠습니다.

이 문제에 관심을 가져주셔서 미리 감사드립니다.

감사합니다,
Michael Everett`,
    koreanNouns: `From: Michael Everett <michael.everett@greenlineindustries.com>
    To: Juanita Wilson <jwilson@customwoodworks.com>
    Subject: Custom Order Inquiry - Wooden Display Stands
    Date: May 10, 2051
    
    Dear Ms. Wilson,
    
    I am writing to inquire about a custom order from your <mark>명성 높은</mark> business. We need <mark>수공예</mark> wooden display stands, each designed to hold three 8x10 frames in a tiered layout, and would like to know if you can fulfill this request and, if so, what the cost and timeline would be.
    
    Our business would require a quantity of 75 units to be delivered by June 15, 2051. Please let us know if this timeline is <mark>실현 가능한</mark> on your end. Any additional details regarding shipping or handling would also be appreciated. We look forward to maintaining our business relationship with your esteemed organization and we trust that you will do your <mark>최선</mark> to fulfill this request to our <mark>상호</mark> satisfaction.
    
    Please get back to me at your earliest convenience. It will be much appreciated if you can provide us with the cost estimate, payment terms, and any other pertinent information relevant to this custom order.
    
    Thank you in advance for your attention to this matter.
    
    Best regards,
    Michael Everett`,
    wordPairs: {
      esteemed: "명성 높은",
      handcrafted: "수공예",
      feasible: "실현 가능한",
      utmost: "최선",
      mutual: "상호",
    },
    questions: [],
  },

  {
    id: 18,
    passage: `Subject: Request for Refund – Order #A12345

Dear Customer Service Representative,

I am writing to request a refund for my recent purchase of a SmartPro Wireless Earbuds(Order #A12345), which I received on February 20. Upon using the product, I discovered that the left earbud does not function properly. Despite following the troubleshooting steps outlined in the user manual, the issue persists.

According to your company's return policy, defective items are eligible for a refund within 30 days of purchase. I would appreciate it if you could process my request at your earliest convenience. I have attached the original receipt and photographs of the item for your reference.

Please confirm the refund process and any additional steps I need to take. I look forward to your prompt response.

Sincerely,
`,
    translation: `제목: 환불 요청 - 주문번호 #A12345

고객 서비스 담당자님께,

2월 20일에 받은 SmartPro 무선 이어폰(주문번호 #A12345) 구매에 대한 환불을 요청드립니다. 제품 사용 중 왼쪽 이어폰이 제대로 작동하지 않는 것을 발견했습니다. 사용자 매뉴얼에 설명된 문제 해결 단계를 따랐음에도 문제가 지속되고 있습니다.

귀사의 반품 정책에 따르면, 결함이 있는 제품은 구매일로부터 30일 이내에 환불이 가능한 것으로 알고 있습니다. 가능한 빠른 시일 내에 제 요청을 처리해 주시면 감사하겠습니다. 참고를 위해 영수증 원본과 제품 사진을 첨부하였습니다.

환불 절차와 제가 추가로 취해야 할 조치가 있다면 알려주시기 바랍니다. 신속한 답변 부탁드립니다.

감사합니다.
`,
    koreanNouns: `Subject: Request for Refund – Order #A12345

Dear Customer Service Representative,

I am writing to request a refund for my recent purchase of a SmartPro Wireless Earbuds(Order #A12345), which I received on February 20. <mark>~하자마자</mark> using the product, I discovered that the left earbud does not function properly. Despite following the <mark>문제 해결</mark> steps outlined in the user manual, the issue <mark>지속된다</mark>.

According to your company's return policy, <mark>결함이 있는</mark> items are <mark>해당되는</mark> for a refund within 30 days of purchase. I would appreciate it if you could process my request at your earliest convenience. I have attached the original receipt and photographs of the item for your reference.

Please confirm the refund process and any additional steps I need to take. I look forward to your prompt response.

Sincerely,
`,
    wordPairs: {
      upon: "~하자마자",
      troubleshooting: "문제 해결",
      persists: "지속된다",
      defective: "결함이 있는",
      eligible: "해당되는",
    },
    questions: [],
  },

  {
    id: 19,
    passage: `Subject: Concern Regarding Product Quality – Order #B67890

Dear Customer Support,

I recently received my order (ProTech Laptop Bag, Order #B67890) and was disappointed with the product's condition. Upon unboxing, I noticed that the zipper was defective, making it difficult to open and close the bag. Additionally, there were visible scratches on the surface, which suggests that the item was either used or mishandled before shipping.

As a loyal customer, I expect high-quality products and reliable service. I would like to request a replacement item or a partial refund as compensation for the defective product. Kindly advise me on how to proceed with this request.

I hope this matter can be resolved quickly. I appreciate your prompt attention.

Sincerely,
Emily Carter
+1-555-789-0123
emily.carter@email.com`,

    translation: `제목: 제품 품질 관련 우려사항 - 주문번호 #B67890

고객지원팀께,

최근 주문한 제품(ProTech 노트북 가방, 주문번호 #B67890)을 받았는데 제품 상태가 실망스러웠습니다. 포장을 풀어보니 지퍼에 결함이 있어 가방을 열고 닫기가 어려웠습니다. 또한 표면에 눈에 띄는 긁힘이 있어, 배송 전에 사용되었거나 잘못 취급된 것으로 보입니다.

충성 고객으로서 저는 고품질의 제품과 신뢰할 수 있는 서비스를 기대합니다. 불량 제품에 대한 보상으로 제품 교체나 부분 환불을 요청하고 싶습니다. 이 요청을 어떻게 진행해야 하는지 안내해 주시기 바랍니다.

이 문제가 신속히 해결되기를 바랍니다. 신속한 관심 부탁드립니다.

감사합니다.
`,

    koreanNouns: `Subject: Concern Regarding Product Quality – Order #B67890

Dear Customer Support,

I recently received my order (ProTech Laptop Bag, Order #B67890) and was disappointed with the product's condition. Upon unboxing, I noticed that the zipper was defective, making it difficult to open and close the bag. Additionally, there were visible scratches on the surface, which suggests that the item was either used or mishandled before shipping.

As a loyal customer, I expect high-quality products and reliable service. I would like to request a replacement item or a partial refund as compensation for the defective product. Kindly advise me on how to proceed with this request.

I hope this matter can be resolved quickly. I appreciate your prompt attention.

Sincerely,
Emily Carter
+1-555-789-0123
emily.carter@email.com`,

    wordPairs: {},

    questions: [],
  },

  {
    id: 20,
    passage: `From: Customer Support Team, Horizon Electronics
  To: Mr. Daniel Lawson
  Date: March 7, 2025
  Subject: Refund Request for Order #HZE-24589
  
  Dear Mr. Lawson,
  
  We appreciate your patience regarding your recent refund request for Order #HZE-24589. After carefully reviewing your case, we regret to hear that the product did not meet your expectations, and we sincerely apologize for any inconvenience this may have caused.
  
  As per our return and refund policy, refunds are processed for items that are returned in their original condition within 30 days of purchase. Our records indicate that your request was submitted beyond the <mark>stipulated</mark> timeframe. However, as a valued customer, we are pleased to offer you an exceptional one-time refund as a gesture of goodwill.
  
  To proceed with the refund, please ensure that the item is <mark>securely</mark> packaged and shipped to our return center using the prepaid shipping label provided in the attachment. Once we receive and inspect the item, your refund will be processed within 7 to 10 business days <mark>via</mark> the original payment method.
  
  If you require further clarification or assistance, please do not hesitate to reach out. We <mark>truly</mark> appreciate your business and look forward to serving you again in the future.
  
  Best regards,
  Customer Support Team
  Horizon Electronics`,

    translation: `발신: 고객지원팀, Horizon Electronics
  수신: Daniel Lawson 님
  날짜: 2025년 3월 7일
  제목: 주문번호 #HZE-24589에 대한 환불 요청
  
  Lawson 님께,
  
  주문번호 #HZE-24589에 대한 최근 환불 요청과 관련하여 기다려 주셔서 감사합니다. 귀하의 사례를 신중히 검토한 결과, 제품이 기대에 미치지 못했다는 점에 대해 유감스럽게 생각하며, 이로 인해 발생한 불편에 대해 진심으로 사과드립니다.
  
  당사의 반품 및 환불 정책에 따르면, 환불은 구매일로부터 30일 이내에 원래 상태로 반품된 물품에 대해 처리됩니다. 당사의 기록에 따르면 귀하의 요청은 규정된 기간을 초과하여 제출되었습니다. 그러나 소중한 고객님께 선의의 표시로 이번 한 번에 한하여 특별 환불을 제공해 드리게 되어 기쁘게 생각합니다.
  
  환불을 진행하시려면, 첨부된 선불 배송 라벨을 사용하여 물품을 안전하게 포장하여 당사의 반품 센터로 발송해 주시기 바랍니다. 물품을 수령하고 검수한 후, 7-10 영업일 이내에 원래의 결제 방식으로 환불이 처리될 예정입니다.
  
  추가 설명이나 도움이 필요하시면 언제든 문의해 주시기 바랍니다. 귀하의 거래에 진심으로 감사드리며, 향후에도 계속해서 서비스를 제공해 드릴 수 있기를 기대합니다.
  
  감사합니다.
  고객지원팀
  Horizon Electronics`,
    koreanNouns: `From: Customer Support Team, Horizon Electronics
  To: Mr. Daniel Lawson
  Date: March 7, 2025
  Subject: Refund Request for Order #HZE-24589
  
  Dear Mr. Lawson,
  
  We appreciate your patience regarding your recent refund request for Order #HZE-24589. After carefully reviewing your case, we regret to hear that the product did not meet your expectations, and we sincerely apologize for any inconvenience this may have caused.
  
  As per our return and refund policy, refunds are processed for items that are returned in their original condition within 30 days of purchase. Our records indicate that your request was submitted beyond the <mark>규정된</mark> timeframe. However, as a valued customer, we are pleased to offer you an exceptional one-time refund as a gesture of goodwill.
  
  To proceed with the refund, please ensure that the item is <mark>안전하게</mark> packaged and shipped to our return center using the prepaid shipping label provided in the attachment. Once we receive and inspect the item, your refund will be processed within 7 to 10 business days <mark>통해</mark> the original payment method.
  
  If you require further clarification or assistance, please do not hesitate to reach out. We <mark>진심으로</mark> appreciate your business and look forward to serving you again in the future.
  
  Best regards,
  Customer Support Team
  Horizon Electronics`,

    wordPairs: {
      stipulated: "규정된",
      securely: "안전하게",
      via: "통해",
      truly: "진심으로",
    },

    questions: [],
  },

  {
    id: 21,
    passage: `Subject: New Account Approval
  
  Dear Mr. Jonathan Reed,
  
  We are pleased to inform you that your new account application has been successfully processed and approved. Your account is now active and ready for use. Please find the key details below:
  
  Account Details:
  
  Account Number: 2356-8745-9123
  Account Type: Savings Account
  Opening Date: March 7, 2025
  
  To ensure a <mark>seamless</mark> banking experience, we encourage you to activate your online banking by following these steps:
  
  Visit our official website at www.horizonbank.com
  Click on "Register for Online Banking"
  Enter your account number and verify your identity
  Set up your login <mark>credentials</mark> and security questions
  
  For security reasons, we advise you to change your temporary PIN immediately and avoid sharing your credentials with anyone. If you have requested a debit card or checkbook, they will be <mark>dispatched</mark> within 5-7 business days.
  
  Should you have any questions or require assistance, please do not hesitate to contact our customer service team at support@horizonbank.com or call us at +1 (800) 555-0199.
  
  We appreciate your trust in Horizon Bank and look forward to serving you.
  
  Best regards,
  Michael Patterson
  Customer Support Team
  Horizon Bank`,

    translation: `제목: 신규 계좌 승인
  
  Jonathan Reed 님께,
  
  귀하의 신규 계좌 신청이 성공적으로 처리되어 승인되었음을 알려드립니다. 귀하의 계좌는 현재 활성화되어 사용 가능한 상태입니다. 주요 세부사항은 아래와 같습니다:
  
  계좌 정보:
  
  계좌번호: 2356-8745-9123
  계좌 유형: 예금 계좌
  개설일: 2025년 3월 7일
  
  원활한 은행 서비스 이용을 위해 다음 단계에 따라 온라인 뱅킹을 활성화하시기를 권장드립니다:
  
  공식 웹사이트 www.horizonbank.com 방문
  "온라인 뱅킹 등록" 클릭
  계좌번호 입력 및 본인 인증
  로그인 정보 및 보안 질문 설정
  
  보안을 위해 임시 PIN을 즉시 변경하시고 계좌 정보를 타인과 공유하지 않으시기를 권고드립니다. 체크카드나 수표책을 신청하신 경우, 영업일 기준 5-7일 내에 발송될 예정입니다.
  
  문의사항이나 도움이 필요하신 경우, support@horizonbank.com으로 이메일을 보내시거나 +1 (800) 555-0199로 고객 서비스 팀에 연락 주시기 바랍니다.
  
  Horizon Bank를 신뢰해 주셔서 감사드리며, 귀하를 모실 수 있기를 기대합니다.
  
  감사합니다.
  Michael Patterson
  고객 지원팀
  Horizon Bank`,

    koreanNouns: `Subject: New Account Approval
  
  Dear Mr. Jonathan Reed,
  
  We are pleased to inform you that your new account application has been successfully processed and approved. Your account is now active and ready for use. Please find the key details below:
  
  Account Details:
  
  Account Number: 2356-8745-9123
  Account Type: Savings Account
  Opening Date: March 7, 2025
  
  To ensure a <mark>원활한</mark> banking experience, we encourage you to activate your online banking by following these steps:
  
  Visit our official website at www.horizonbank.com
  Click on "Register for Online Banking"
  Enter your account number and verify your identity
  Set up your login <mark>자격정보</mark> and security questions
  
  For security reasons, we advise you to change your temporary PIN immediately and avoid sharing your credentials with anyone. If you have requested a debit card or checkbook, they will be <mark>발송될</mark> within 5-7 business days.
  
  Should you have any questions or require assistance, please do not hesitate to contact our customer service team at support@horizonbank.com or call us at +1 (800) 555-0199.
  
  We appreciate your trust in Horizon Bank and look forward to serving you.
  
  Best regards,
  Michael Patterson
  Customer Support Team
  Horizon Bank`,

    wordPairs: {
      seamless: "원활한",
      credentials: "자격정보",
      dispatched: "발송될",
    },

    questions: [],
  },
  {
    id: 22,
    passage: `Subject: Initial Deposit Confirmation
  
  Dear Ms. Emily Park,
  
  We are pleased to confirm that your initial deposit of $2,500 has been successfully credited to your newly opened Horizon Bank Savings Account. Below are the transaction details for your reference:
  
  Transaction Summary:
  
  <mark>Account Holder</mark>: Emily Park
  <mark>Account Number</mark>: 6789-1234-5678
  <mark>Deposit Amount</mark>: $2,500.00
  Transaction Date: March 7, 2025
  Deposit Method: <mark>Direct Transfer</mark> from External Bank
  
  Please note that a minimum balance of $500 is required to maintain your account in active status. If your balance falls below this <mark>threshold</mark>, a monthly service fee of $15 will be <mark>deducted</mark>.
  
  Additionally, your account is eligible for an annual interest rate of 1.8%, which will be calculated on a <mark>compound</mark> <mark>quarterly</mark> basis. To maximize your savings, we recommend setting up an automatic direct deposit or enrolling in our fixed-term deposit options for higher interest rates.
  
  You may access your account balance, <mark>transaction</mark> history, and e-statements at any time through Horizon Bank Online Banking. If you have not yet activated your online banking profile, please visit www.horizonbank.com and complete the registration process.
  
  For any inquiries regarding your deposit or account features, please contact our Customer Service Team at support@horizonbank.com or call us at +1 (800) 555-0199.
  
  We appreciate your trust in Horizon Bank and look forward to serving you.
  
  Best regards,
  Daniel Roberts
  Customer Support Manager
  Horizon Bank`,

    translation: `제목: 초기 입금 확인
  
  Emily Park 고객님께,
  
  고객님의 신규 개설된 Horizon Bank 저축 계좌에 초기 입금액 $2,500이 성공적으로 입금되었음을 확인해 드립니다. 아래는 참고하실 거래 내역입니다:
  
  거래 내역:
  
  계좌 소유주: Emily Park
  계좌 번호: 6789-1234-5678
  입금액: $2,500.00
  거래일: 2025년 3월 7일
  입금 방법: 외부 은행에서 직접 이체
  
  계좌를 활성 상태로 유지하기 위해서는 최소 잔액 $500이 필요합니다. 잔액이 이 기준 미만으로 떨어질 경우, 월 서비스 수수료 $15가 차감됩니다.
  
  또한, 고객님의 계좌는 연 이율 1.8%를 적용받으며, 이는 분기별로 복리 계산됩니다. 저축을 최대화하기 위해 자동 직접 입금을 설정하시거나 더 높은 이율을 제공하는 정기 예금 상품에 가입하시는 것을 추천드립니다.
  
  Horizon Bank 온라인 뱅킹을 통해 언제든지 계좌 잔액, 거래 내역, 전자명세서를 확인하실 수 있습니다. 아직 온라인 뱅킹 프로필을 활성화하지 않으셨다면, www.horizonbank.com을 방문하여 등록 절차를 완료해 주시기 바랍니다.
  
  입금이나 계좌 기능에 대해 문의사항이 있으시면 고객 서비스팀(이메일: support@horizonbank.com, 전화: +1 (800) 555-0199)으로 연락 주시기 바랍니다.
  
  Horizon Bank를 신뢰해 주셔서 감사드리며, 앞으로도 최선을 다해 서비스하겠습니다.
  
  감사합니다.
  Daniel Roberts
  고객 지원 매니저
  Horizon Bank`,

    koreanNouns: `Subject: Initial Deposit Confirmation
  
  Dear Ms. Emily Park,
  
  We are pleased to confirm that your initial deposit of $2,500 has been successfully credited to your newly opened Horizon Bank Savings Account. Below are the transaction details for your reference:
  
  Transaction Summary:
  
  <mark>계좌 소유주</mark>: Emily Park
  <mark>계좌 번호</mark>: 6789-1234-5678
  <mark>입금액</mark>: $2,500.00
  Transaction Date: March 7, 2025
  Deposit Method: <mark>직접 이체</mark> from External Bank
  
  Please note that a minimum balance of $500 is required to maintain your account in active status. If your balance falls below this <mark>기준</mark>, a monthly service fee of $15 will be <mark>차감됩니다</mark>.
  
  Additionally, your account is eligible for an annual interest rate of 1.8%, which will be calculated on a <mark>복리</mark> <mark>분기별로</mark> basis. To maximize your savings, we recommend setting up an automatic direct deposit or enrolling in our fixed-term deposit options for higher interest rates.
  
  You may access your account balance, <mark>거래 내역</mark> history, and e-statements at any time through Horizon Bank Online Banking. If you have not yet activated your online banking profile, please visit www.horizonbank.com and complete the registration process.
  
  For any inquiries regarding your deposit or account features, please contact our Customer Service Team at support@horizonbank.com or call us at +1 (800) 555-0199.
  
  We appreciate your trust in Horizon Bank and look forward to serving you.
  
  Best regards,
  Daniel Roberts
  Customer Support Manager
  Horizon Bank`,

    wordPairs: {
      "Account Holder": "계좌 소유주",
      "Account Number": "계좌 번호",
      "Deposit Amount": "입금액",
      "Direct Transfer": "직접 이체",
      transaction: "거래 내역",
      threshold: "기준",
      deducted: "차감됩니다",
      compound: "복리",
      quarterly: "분기별로",
    },

    questions: [],
  },
  {
    id: 23,
    passage: `Subject: Appreciation for Outstanding Customer Support
  
  Dear Customer Service Team,
  
  I am writing to express my sincere appreciation for the excellent support I received from your team regarding my recent order (Order #D45678). Your representative, Mr. Andrew Carter, was extremely professional and efficient in resolving my issue.
  
  Despite my request being <mark>somewhat</mark> complicated, Mr. Carter handled it with patience and <mark>expertise</mark>. Thanks to his <mark>prompt</mark> assistance, my concern was addressed within 24 hours, exceeding my expectations.
  
  I truly appreciate the <mark>dedication</mark> and professionalism of your customer service team. I will continue to be a loyal customer and will not hesitate to recommend your company to others.
  
  Sincerely,
  Olivia Patterson
  +1-555-321-6789
  olivia.patterson@email.com`,

    translation: `제목: 뛰어난 고객 지원에 대한 감사
  
  고객 서비스팀 귀중,
  
  최근 주문(주문번호 #D45678)과 관련하여 귀 팀으로부터 받은 훌륭한 지원에 대해 진심으로 감사드립니다. 귀사의 담당자인 Andrew Carter씨는 제 문제를 해결하는데 있어 매우 전문적이고 효율적이었습니다.
  
  제 요청이 다소 복잡했음에도 불구하고, Carter씨는 인내심과 전문성을 가지고 처리해 주셨습니다. 그의 신속한 지원 덕분에 제 문제가 24시간 이내에 해결되어 기대 이상이었습니다.
  
  귀사의 고객 서비스팀의 헌신과 전문성에 깊이 감사드립니다. 저는 계속해서 충성 고객이 될 것이며, 다른 분들에게도 귀사를 추천하는 것을 주저하지 않을 것입니다.
  
  감사합니다.
  `,
    koreanNouns: `Subject: Appreciation for Outstanding Customer Support
  
  Dear Customer Service Team,
  
  I am writing to express my sincere appreciation for the excellent support I received from your team regarding my recent order (Order #D45678). Your representative, Mr. Andrew Carter, was extremely professional and efficient in resolving my issue.
  
  Despite my request being <mark>다소</mark> complicated, Mr. Carter handled it with patience and <mark>전문성</mark>. Thanks to his <mark>신속한</mark> assistance, my concern was addressed within 24 hours, exceeding my expectations.
  
  I truly appreciate the <mark>헌신</mark> and professionalism of your customer service team. I will continue to be a loyal customer and will not hesitate to recommend your company to others.
  
  Sincerely,
  Olivia Patterson
  +1-555-321-6789
  olivia.patterson@email.com`,

    wordPairs: {
      somewhat: "다소",
      expertise: "전문성",
      prompt: "신속한",
      dedication: "헌신",
    },

    questions: [],
  },

  {
    id: 24,
    passage: `Subject: Invoice & Payment Request – Due by March 15, 2025
Dear Ms. Olivia Carter,

We are reaching out to remind you that Invoice #HZN-48231 is currently <mark>outstanding</mark> and requires payment by March 15, 2025. Below are the details of the invoice:

Invoice Summary
- Invoice Number: HZN-48231
- Invoice Date: March 1, 2025
- Total Amount Due: $3,250.00
- Due Date: March 15, 2025
- Payment Method: Bank Transfer / Credit Card

Payment Instructions
For your convenience, payment can be made via bank transfer using the details below:

Bank Name: Horizon Bank
Account Number: 123-456-789
SWIFT Code: HZNBUS33
Reference: Invoice #HZN-48231
Alternatively, you may process your payment <mark>securely</mark> through our online payment portal at www.horizoncompany.com/payments.

Late Payment Policy
If payment is not received by the due date, a late fee of 5% will be applied to the outstanding balance, and your account may <mark>be subject to</mark> temporary <mark>suspension</mark>. To avoid any disruption to your services, we kindly request that payment be made by the specified deadline.

Should you have any questions regarding this invoice or require an extension, please contact our Billing Department at billing@horizoncompany.com.

Thank you for your prompt attention to this matter.

Best regards,
Daniel Roberts
Accounts Receivable Team
Horizon Solutions`,

    translation: `제목: 청구서 및 지불 요청 - 2025년 3월 15일까지
올리비아 카터 님께,

청구서 #HZN-48231이 현재 미결제 상태이며 2025년 3월 15일까지 지불이 필요함을 상기시켜 드립니다. 아래는 청구서의 상세 내용입니다:

청구서 요약
- 청구서 번호: HZN-48231
- 청구일: 2025년 3월 1일
- 총 미결제 금액: $3,250.00
- 지불 기한: 2025년 3월 15일
- 지불 방법: 계좌이체 / 신용카드

지불 안내
편의를 위해 아래 정보를 사용하여 계좌이체로 지불하실 수 있습니다:

은행명: 호라이즌 은행
계좌번호: 123-456-789
SWIFT 코드: HZNBUS33
참조: 청구서 #HZN-48231
또는 www.horizoncompany.com/payments에서 온라인 결제 포털을 통해 안전하게 결제하실 수 있습니다.

연체 정책
기한까지 지불이 이루어지지 않을 경우, 미결제 잔액에 5%의 연체료가 부과되며, 계정이 일시적으로 정지될 수 있습니다. 서비스 중단을 피하기 위해 지정된 기한까지 지불해 주시기를 부탁드립니다.

이 청구서에 대해 문의사항이 있거나 기한 연장이 필요하신 경우, billing@horizoncompany.com으로 청구 부서에 연락해 주시기 바랍니다.

신속한 처리 부탁드립니다.

감사합니다.
대니얼 로버츠
미수금 관리팀
호라이즌 솔루션즈`,

    koreanNouns: `Subject: Invoice & Payment Request – Due by March 15, 2025
Dear Ms. Olivia Carter,

We are reaching out to remind you that Invoice #HZN-48231 is currently <mark>미결제된</mark> and requires payment by March 15, 2025. Below are the details of the invoice:

Invoice Summary
- Invoice Number: HZN-48231
- Invoice Date: March 1, 2025
- Total Amount Due: $3,250.00
- Due Date: March 15, 2025
- Payment Method: Bank Transfer / Credit Card

Payment Instructions
For your convenience, payment can be made via bank transfer using the details below:

Bank Name: Horizon Bank
Account Number: 123-456-789
SWIFT Code: HZNBUS33
Reference: Invoice #HZN-48231
Alternatively, you may process your payment <mark>안전하게</mark> through our online payment portal at www.horizoncompany.com/payments.

Late Payment Policy
If payment is not received by the due date, a late fee of 5% will be applied to the outstanding balance, and your account may <mark>~의 대상이 될 수 있습니다</mark> temporary <mark>정지</mark>. To avoid any disruption to your services, we kindly request that payment be made by the specified deadline.

Should you have any questions regarding this invoice or require an extension, please contact our Billing Department at billing@horizoncompany.com.

Thank you for your prompt attention to this matter.

Best regards,
Daniel Roberts
Accounts Receivable Team
Horizon Solutions`,

    wordPairs: {
      outstanding: "미결제된",
      securely: "안전하게",
      "be subject to": "~의 대상이 될 수 있습니다",
      suspension: "정지",
    },

    questions: [],
  },

  {
    id: 25,
    passage: `Subject: Important Notice: Product Recall & Exchange Procedure
  
  Dear Valued Customer,
  
  At NovaTech Electronics, we are committed to delivering high-quality and <mark>reliable</mark> products. However, after conducting a <mark>thorough</mark> quality inspection, we have identified a potential <mark>defect</mark> in a specific batch of our NovaSound X200 Wireless Earbuds that may affect <mark>optimal</mark> performance.
  
  To ensure the safety and satisfaction of our customers, we are <mark>initiating</mark> a voluntary recall of this product. If you have purchased a unit with the serial numbers NSX200-20240301 to NSX200-20240415, we kindly ask you to follow the simple exchange process outlined below:
  
  - Confirm Your Eligibility: Check your product's serial number on the original packaging or device settings.
  - Request a Replacement: Visit our official recall page [link] and complete the exchange request form.
  - Return the Affected Product: We will provide a prepaid shipping label for you to send back the recalled unit at no additional cost.
  - Receive a New Unit: Once we receive your return, a brand-new replacement unit will be shipped to you immediately.
  
  We sincerely apologize for any inconvenience this may cause and appreciate your prompt cooperation. Ensuring the highest product standards remains our top priority, and we are working <mark>diligently</mark> to resolve this issue as efficiently as possible.
  
  If you have any questions or require further assistance, please do not hesitate to contact our dedicated customer support team at support@novatechelectronics.com.
  
  Thank you for your trust and loyalty.
  
  Best regards,
  Olivia Reynolds
  Customer Support Manager
  NovaTech Electronics`,

    translation: `제목: 중요 공지: 제품 리콜 및 교환 절차
  
  고객님께,
  
  노바테크 일렉트로닉스는 고품질의 신뢰할 수 있는 제품을 제공하기 위해 최선을 다하고 있습니다. 그러나 철저한 품질 검사를 실시한 결과, 노바사운드 X200 무선 이어버드의 특정 배치에서 최적의 성능에 영향을 미칠 수 있는 잠재적 결함을 발견했습니다.
  
  고객의 안전과 만족을 보장하기 위해 이 제품에 대한 자발적 리콜을 시작합니다. 시리얼 번호 NSX200-20240301부터 NSX200-20240415까지의 제품을 구매하신 경우, 아래에 설명된 간단한 교환 절차를 따라주시기 바랍니다:
  
  자격 확인: 원래 포장이나 기기 설정에서 제품의 시리얼 번호를 확인하세요.
  교체 요청: 공식 리콜 페이지 [링크]를 방문하여 교환 요청 양식을 작성하세요.
  영향받은 제품 반품: 추가 비용 없이 리콜된 제품을 반송할 수 있는 선불 배송 라벨을 제공해 드립니다.
  새 제품 수령: 반품을 받는 즉시 새로운 교체 제품을 즉시 발송해 드립니다.
  이로 인해 발생할 수 있는 불편에 진심으로 사과드리며 신속한 협조에 감사드립니다. 최고의 제품 표준을 보장하는 것이 저희의 최우선 과제이며, 이 문제를 가능한 효율적으로 해결하기 위해 성실히 노력하고 있습니다.
  
  질문이 있거나 추가 도움이 필요하시면 언제든지 support@novatechelectronics.com으로 전담 고객 지원팀에 문의해 주십시오.
  
  귀하의 신뢰와 충성에 감사드립니다.
  
  감사합니다.
  올리비아 레이놀즈
  고객 지원 관리자
  노바테크 일렉트로닉스`,

    koreanNouns: `Subject: Important Notice: Product Recall & Exchange Procedure
  
  Dear Valued Customer,
  
  At NovaTech Electronics, we are committed to delivering high-quality and <mark>신뢰할 수 있는</mark> products. However, after conducting a <mark>철저한</mark> quality inspection, we have identified a potential <mark>결함</mark> in a specific batch of our NovaSound X200 Wireless Earbuds that may affect <mark>최적의</mark> performance.
  
  To ensure the safety and satisfaction of our customers, we are <mark>시작합니다</mark> a voluntary recall of this product. If you have purchased a unit with the serial numbers NSX200-20240301 to NSX200-20240415, we kindly ask you to follow the simple exchange process outlined below:
  
  - Confirm Your Eligibility: Check your product's serial number on the original packaging or device settings.
  - Request a Replacement: Visit our official recall page [link] and complete the exchange request form.
  - Return the Affected Product: We will provide a prepaid shipping label for you to send back the recalled unit at no additional cost.
  - Receive a New Unit: Once we receive your return, a brand-new replacement unit will be shipped to you immediately.
  
  We sincerely apologize for any inconvenience this may cause and appreciate your prompt cooperation. Ensuring the highest product standards remains our top priority, and we are working <mark>성실히</mark> to resolve this issue as efficiently as possible.
  
  If you have any questions or require further assistance, please do not hesitate to contact our dedicated customer support team at support@novatechelectronics.com.
  
  Thank you for your trust and loyalty.
  
  Best regards,
  Olivia Reynolds
  Customer Support Manager
  NovaTech Electronics`,

    wordPairs: {
      reliable: "신뢰할 수 있는",
      thorough: "철저한",
      defect: "결함",
      optimal: "최적의",
      initiating: "시작합니다",
      diligently: "성실히",
    },

    questions: [],
  },
];
